<!-- No menubar-hoverable/header-fixed/menubar-pin wrapper here —
     LayoutComponent (the parent route shell) already applies those same
     classes directly to <body> in its own ngOnInit (see
     layout.component.ts), so body already carries them by the time this
     component renders; duplicating them on a wrapper div here only risks
     a second, redundant .menubar-pin ancestor without adding anything the
     CSS cascade needs. -->
<div id="base">
  <div class="offcanvas"></div>
  <!--end .offcanvas-->

  <div id="content">
    <section class="fv2-section">

      <!-- Page head -->
  <div class="fv2-page-head">
    <div class="fv2-tabs" role="tablist" aria-label="Fees Sections" #tabsTrack *ngIf="hasAnyFeesTab">
      <span class="fv2-tab-indicator" aria-hidden="true" #tabIndicator></span>
      <button type="button" class="fv2-tab" *ngIf="canSeeOverview" [class.active]="activeTab === 'overview'" role="tab"
        [attr.aria-selected]="activeTab === 'overview'" (click)="setActiveTab('overview')">{{ 'overview' | translate }}</button>
      <button type="button" class="fv2-tab" *ngIf="canSeeFeesBoard" [class.active]="activeTab === 'feesBoard'" role="tab"
        [attr.aria-selected]="activeTab === 'feesBoard'" (click)="setActiveTab('feesBoard')">{{ 'fv2FeesBoard' | translate }}</button>
      <button type="button" class="fv2-tab" *ngIf="canSeeFeeCollection" [class.active]="activeTab === 'feeCollection'" role="tab"
        [attr.aria-selected]="activeTab === 'feeCollection'" (click)="setActiveTab('feeCollection')">{{ 'fv2FeeCollection' | translate }}</button>
      <button type="button" class="fv2-tab" *ngIf="canSeeDiscounts" [class.active]="activeTab === 'discounts'" role="tab"
        [attr.aria-selected]="activeTab === 'discounts'" (click)="setActiveTab('discounts')">{{ 'fv2Discounts' | translate }}</button>
      <button type="button" class="fv2-tab" *ngIf="canSeeSettings" [class.active]="activeTab === 'settings'" role="tab"
        [attr.aria-selected]="activeTab === 'settings'" (click)="setActiveTab('settings')">{{ 'settings' | translate }}</button>
    </div>

    <div style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">
      <a class="fv2-btn-ghost" [routerLink]="['/fees']" [title]="'fv2UseOldFeesManagement' | translate">
        <i class="ph ph-arrow-counter-clockwise"></i><span>{{ 'fv2UseOldFeesManagement' | translate }}</span>
      </a>
      <div class="fv2-page-sub">
        <select class="fv2-year-select" aria-label="Academic Year" [ngModel]="currentAcademicId"
          (ngModelChange)="academicChanged($event)" [ngModelOptions]="{standalone: true}">
          <option *ngFor="let ac of academicList" [ngValue]="ac.pkAcademicId">
            {{ ac.Year }}<ng-container *ngIf="ac.current"> ({{ 'fv2Current' | translate }})</ng-container>
          </option>
        </select>
      </div>
    </div>
  </div>

  <!-- Overview tab -->
  <ng-container *ngIf="activeTab === 'overview'">

    <!-- Student status toggle — switches the stat cards below between the
         school-wide total and the active-only / inactive-only slices the
         API returns in the same response (no extra request per toggle). -->
    <div class="fv2-status-toggle" role="tablist" aria-label="Student status">
      <button type="button" class="fv2-status-toggle-btn" [class.active]="studentStatusFilter === 'total'"
        (click)="setStudentStatusFilter('total')">{{ 'all' | translate }}</button>
      <button type="button" class="fv2-status-toggle-btn" [class.active]="studentStatusFilter === 'active'"
        (click)="setStudentStatusFilter('active')">{{ 'active' | translate }}</button>
      <button type="button" class="fv2-status-toggle-btn" [class.active]="studentStatusFilter === 'inactive'"
        (click)="setStudentStatusFilter('inactive')">{{ 'inactive' | translate }}</button>
    </div>

    <!-- Stat cards -->
    <div class="fv2-stats">
      <div class="fv2-stat">
        <span class="fv2-stat-icon fv2-t-berry"><i class="ph ph-coins"></i></span>
        <span class="fv2-stat-text">
          <span class="fv2-label">{{ 'totalFees' | translate }}</span>
          <strong class="fv2-num" [countUp]="totalAmount" [countUpPrefix]="currencySymbol"></strong>
        </span>
      </div>
      <div class="fv2-stat fv2-stat-collected" tabindex="0">
        <span class="fv2-stat-icon fv2-t-teal"><i class="ph ph-wallet"></i></span>
        <span class="fv2-stat-text">
          <span class="fv2-label">{{ 'collectedFees' | translate }}</span>
          <strong class="fv2-num" [countUp]="collectedAmount" [countUpPrefix]="currencySymbol"></strong>
        </span>

        <!-- Collection progress — hidden until this stat card is
             hovered/focused; shows the animated bar + legend only then,
             not as an always-visible element on the page. -->
        <div class="fv2-pc-hover-panel">
          <div class="fv2-pc-top">
            <div>
              <div class="fv2-pc-title">{{ 'collectionProgress' | translate }}</div>
              <div class="fv2-pc-amount">{{ currencySymbol }}{{ collectedAmount | number }}
                <small>{{ 'collectedOf' | translate }} {{ currencySymbol }}{{ totalAmount | number }}</small>
              </div>
            </div>
            <span class="fv2-pc-rate"><i class="ph ph-warning-circle"></i>{{ collectionPercent | number:'1.1-1' }}% {{ 'fv2Collected' | translate }}</span>
          </div>
          <div class="fv2-bar" role="img"
            [attr.aria-label]="'Collected ' + (collectedAmount | number) + ', discounts ' + (discountAmount | number) + ', pending ' + (pendingAmount | number) + ', late ' + (lateFeesAmount | number)">
            <span class="fv2-b-collected" *ngIf="collectedAmount > 0" [style.width.%]="barSegmentPercent(collectedAmount)"></span>
            <span class="fv2-b-discount" *ngIf="discountAmount > 0" [style.width.%]="barSegmentPercent(discountAmount)"></span>
            <span class="fv2-b-pending" *ngIf="pendingAmount > 0" [style.width.%]="barSegmentPercent(pendingAmount)"></span>
            <span class="fv2-b-late" *ngIf="lateFeesAmount > 0" [style.width.%]="barSegmentPercent(lateFeesAmount)"></span>
          </div>
          <div class="fv2-legend-row">
            <div><i class="fv2-dot" style="background:var(--fv2-teal)"></i>{{ 'fv2Collected' | translate }} <b>{{ currencySymbol }}{{ collectedAmount | number }}</b></div>
            <div><i class="fv2-dot" style="background:var(--fv2-maple)"></i>{{ 'fv2Discounts' | translate }} <b>{{ currencySymbol }}{{ discountAmount | number }}</b></div>
            <div><i class="fv2-dot" style="background:#C7D0CC"></i>{{ 'pending' | translate }} <b>{{ currencySymbol }}{{ pendingAmount | number }}</b></div>
            <div><i class="fv2-dot" style="background:var(--fv2-berry)"></i>{{ 'lateFees' | translate }} <b>{{ currencySymbol }}{{ lateFeesAmount | number }}</b></div>
          </div>
        </div>
      </div>
      <div class="fv2-stat">
        <span class="fv2-stat-icon fv2-t-maple"><i class="ph ph-seal-percent"></i></span>
        <span class="fv2-stat-text">
          <span class="fv2-label">{{ 'discountsGiven' | translate }}</span>
          <strong class="fv2-num" [countUp]="discountAmount" [countUpPrefix]="currencySymbol"></strong>
        </span>
      </div>
      <div class="fv2-stat">
        <span class="fv2-stat-icon fv2-t-slate"><i class="ph ph-hourglass"></i></span>
        <span class="fv2-stat-text">
          <span class="fv2-label">{{ 'pendingFees' | translate }}</span>
          <strong class="fv2-num" [countUp]="pendingAmount" [countUpPrefix]="currencySymbol"></strong>
        </span>
      </div>
      <div class="fv2-stat">
        <span class="fv2-stat-icon fv2-t-sky"><i class="ph ph-clock-countdown"></i></span>
        <span class="fv2-stat-text">
          <span class="fv2-label">{{ 'lateFees' | translate }}</span>
          <strong class="fv2-num" [countUp]="lateFeesAmount" [countUpPrefix]="currencySymbol"></strong>
        </span>
      </div>
    </div>

    <!-- Fee details -->
    <div class="fv2-panel">
      <div class="fv2-details-head">
        <h3>{{ 'feeDetails' | translate }}</h3>

        <div class="fv2-filter-group" role="group" aria-label="Period" (mouseleave)="closePeriodDropdown()">
          <span class="fv2-fg-label" [attr.aria-label]="'period' | translate" title="{{ 'period' | translate }}">
            <span class="fv2-fg-icon"><i class="ph ph-calendar-blank"></i></span>
          </span>
          <div class="fv2-fg-item fv2-fg-dropdown applied">
            <button type="button" class="fv2-fg-dropdown-toggle" (click)="periodDropdownOpen = !periodDropdownOpen"
              [attr.aria-label]="'period' | translate">
              {{ selectedPeriodLabel }}
              <i class="ph ph-caret-down"></i>
            </button>
            <ul class="fv2-fg-dropdown-menu" *ngIf="periodDropdownOpen">
              <li *ngFor="let option of periodOptions" [class.active]="selectedPeriod === option.value">
                <a (click)="selectPeriod(option.value)">{{ option.label }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="fv2-filter-group" role="group" aria-label="Scope" (mouseleave)="closeScopeDropdown()">
          <button type="button" class="fv2-fg-label" (click)="resetScope($event)" [attr.aria-label]="'resetScope' | translate">
            <span class="fv2-fg-icon"><i class="ph ph-buildings"></i></span>
            <span class="fv2-fg-x"><i class="ph ph-x"></i></span>
          </button>
          <div class="fv2-fg-item fv2-fg-dropdown" [class.applied]="selectedScope !== 'all'">
            <button type="button" class="fv2-fg-dropdown-toggle" (click)="scopeDropdownOpen = !scopeDropdownOpen"
              [attr.aria-label]="'scope' | translate">
              {{ selectedScopeLabel }}
              <i class="ph ph-caret-down"></i>
            </button>
            <ul class="fv2-fg-dropdown-menu" *ngIf="scopeDropdownOpen">
              <li *ngFor="let option of scopeOptions" [class.active]="selectedScope === option.value">
                <a (click)="selectScope(option.value)">{{ option.label }}</a>
              </li>
            </ul>
          </div>
        </div>

        <button type="button" class="fv2-btn-ghost" *ngIf="detailsLoaded && filteredClassFeeRows.length > 0" (click)="openStandardFeeExportPopup()">
          <i class="ph ph-upload-simple"></i><span>{{ 'export' | translate }}</span>
        </button>
        <button type="button" class="fv2-btn-primary" (click)="viewFeeDetails()">
          <i class="ph ph-eye"></i><span>{{ 'viewFeeDetails' | translate }}</span>
        </button>
      </div>

      <div class="fv2-details-body" [class.fading]="detailsFading">
        <div class="fv2-empty" *ngIf="!detailsLoaded && !detailsLoading">
          <span class="fv2-em-icon"><i class="ph ph-receipt"></i></span>
          <b>{{ 'noDetailsLoadedYet' | translate }}</b>
          {{ 'choosePeriodAndScopeHelper' | translate }}
        </div>

        <div class="fv2-wrap" *ngIf="detailsLoaded">
          <table class="fv2-table">
            <thead>
              <tr>
                <th>{{ 'studentClass' | translate }}</th>
                <th>{{ 'totalFees' | translate }}</th>
                <th>{{ 'fv2Discounts' | translate }}</th>
                <th>{{ 'fv2Collected' | translate }}</th>
                <th>{{ 'pending' | translate }}</th>
                <th>{{ 'collection' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filteredClassFeeRows; let i = index" [rowEntrance]="row.classNumber + row.classDivision"
                style="cursor:pointer;" (click)="openClassFeeDetail(row)">
                <td><span class="fv2-class-pill">{{ row.classNumber }}-{{ row.classDivision }}</span></td>
                <td class="fv2-money">{{ currencySymbol }}{{ row.totalFee | number }}</td>
                <td>{{ currencySymbol }}{{ row.discountFee | number }}</td>
                <td class="fv2-money">{{ currencySymbol }}{{ row.collectedFee | number }}</td>
                <td class="fv2-money fv2-pending">{{ currencySymbol }}{{ row.pendingFee | number }}</td>
                <td>
                  <span class="fv2-mini-bar"><span [style.width.%]="row.collectionPercent"></span></span>
                  <span class="fv2-pct">{{ row.collectionPercent | number:'1.1-1' }}%</span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>{{ 'total' | translate }}</td>
                <td class="fv2-money">{{ currencySymbol }}{{ breakdownTotals.totalFee | number }}</td>
                <td>{{ currencySymbol }}{{ breakdownTotals.discountFee | number }}</td>
                <td class="fv2-money">{{ currencySymbol }}{{ breakdownTotals.collectedFee | number }}</td>
                <td class="fv2-money fv2-pending">{{ currencySymbol }}{{ breakdownTotals.pendingFee | number }}</td>
                <td><span class="fv2-pct" style="margin-left:0">{{ breakdownTotalPercent | number:'1.1-1' }}%</span></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <!-- Class fee-configuration drill-down modal — ports
         FeesManagementComponent's #studentFeeDetail modal/viewStudentFees()
         1:1 for information content (per-student, per-fee-type breakdown
         + bus fare + totals + Dues/Collected filter), restyled in the
         fv2-* modal language. The "select overdue → send SMS" sub-flow is
         NOT ported — out of scope (messaging, not fee configuration). -->
    <div class="fv2-modal-backdrop" *ngIf="classFeeDetailOpen" (click)="closeClassFeeDetail()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'classFeeDetails' | translate }} — {{ classFeeDetailClass?.classNumber }}-{{ classFeeDetailClass?.classDivision }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeClassFeeDetail()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="classFeeDetailLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>

          <ng-container *ngIf="!classFeeDetailLoading">
            <div class="fv2-field-row" style="align-items:center; margin-bottom:14px;">
              <div class="fv2-receipt-legend">
                <span class="fv2-legend-dot fv2-legend-collected"></span>{{ 'feesPaid' | translate }}
                <span class="fv2-legend-dot fv2-legend-overdue"></span>{{ 'overDues' | translate }}
                <span class="fv2-legend-dot fv2-legend-blocked"></span>{{ 'deactivated' | translate }}
              </div>
              <select class="fv2-field-input" style="width:auto; margin-left:auto;" [ngModel]="classFeeDetailFilter" (ngModelChange)="setClassFeeDetailFilter($event)">
                <option value="ALL">{{ 'all' | translate }}</option>
                <option value="DUES">{{ 'dues' | translate }}</option>
                <option value="COLLECTED">{{ 'collected' | translate }}</option>
              </select>
              <button type="button" class="fv2-btn-ghost" *ngIf="filteredClassFeeDetailStudents.length > 0" (click)="openClassFeeDetailExport()">
                <i class="ph ph-upload-simple"></i><span>{{ 'export' | translate }}</span>
              </button>
            </div>

            <div class="fv2-empty" *ngIf="filteredClassFeeDetailStudents.length === 0">
              <b>{{ 'noDataAvailableInTable' | translate }}</b>
            </div>

            <div class="fv2-wrap" *ngIf="filteredClassFeeDetailStudents.length > 0">
              <table class="fv2-table">
                <thead>
                  <tr>
                    <th>{{ 'studentName' | translate }}</th>
                    <th>{{ 'parentName' | translate }}</th>
                    <th>{{ 'feeStructure' | translate }}</th>
                    <th *ngFor="let f of classFeeDetailHeaderFees">{{ f.FeeName }} {{ 'pending' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'busFare' | translate }} {{ 'pending' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'totalCollected' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'totalPending' | translate }} ({{ currencySymbol }})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of filteredClassFeeDetailStudents" [class.fv2-row-blocked]="s.isBlocked === 1">
                    <td class="fv2-money" [title]="s.studentName">{{ truncateStudentName(s.studentName) }}</td>
                    <td [title]="s.parentName">{{ truncateStudentName(s.parentName) }}</td>
                    <td>{{ s.structureName || 'Default' }}</td>
                    <td *ngFor="let f of classFeeDetailHeaderFees">
                      <ng-container *ngIf="s.feeByType[f.feesId] as fd; else fv2NaCell">
                        <span [class.fv2-pending-overdue]="fd.isOverdue" [class.fv2-pending-collected]="fd.isCollected">{{ fd.pending }}</span>
                      </ng-container>
                      <ng-template #fv2NaCell>{{ 'na' | translate }}</ng-template>
                    </td>
                    <td>
                      <span *ngIf="s.busFare != null" [class.fv2-pending-collected]="s.busPending === 0">{{ s.busPending }}</span>
                      <ng-container *ngIf="s.busFare == null">{{ 'na' | translate }}</ng-container>
                    </td>
                    <td class="fv2-money">{{ s.totalCollected }}</td>
                    <td class="fv2-money fv2-pending">{{ s.totalPending }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeClassFeeDetail()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Class fee-detail export popup — ports FeesManagementComponent's
         excelExportPopUp dialog 1:1 (ts:7674-7727, html:5225-5434):
         Standard Options (standardOption/downloadPendingReport, same
         cascading on/off behavior) + Advance Filter column toggles +
         Download Pending Fees Report's active/deactive student filter.
         Export output only omits the old component's separate
         "other fees" column set, since this drill-down never fetches
         per-student other-fee data (see TS scope note). -->
    <div class="fv2-modal-backdrop" *ngIf="classFeeDetailExportOpen" (click)="closeClassFeeDetailExport()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'optionExport' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeClassFeeDetailExport()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-export-section-label">{{ 'standardOptions' | translate }}</div>
          <div class="fv2-export-toggle-grid">
            <div class="fv2-export-toggle-item">
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="cfdStandardOption" (ngModelChange)="onCfdStandardOptionChange($event)" />
                {{ 'standardOptionMessage' | translate }}
              </label>
              <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'standardOptionInfo' | translate }}</span>
            </div>
            <div class="fv2-export-toggle-item">
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="cfdDownloadPendingReport" (ngModelChange)="onCfdDownloadPendingReportChange($event)" />
                {{ 'downloadPendingFeesReport' | translate }}
              </label>
              <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'downloadPendingFeesReportInfo' | translate }}</span>
            </div>
          </div>

          <ng-container *ngIf="!cfdDownloadPendingReport">
            <div class="fv2-export-section-label">{{ 'advanceFilter' | translate }}</div>
            <div class="fv2-export-toggle-grid">
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowActualFees" />
                  {{ 'actualFees' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showActualFees' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowTotalCollected" />
                  {{ 'totalCollectedFees' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showTotalCollected' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowTotalPending" />
                  {{ 'totalPendingFees' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showTotalPending' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowRowLevelTotal" />
                  {{ 'rowLevelTotal' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showRowLevelTotal' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowColumnLevelTotal" />
                  {{ 'columnLevelTotal' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showColumnLevelTotal' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowGrandTotal" />
                  {{ 'showGrandTotal' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showGrandTotalDescription' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowBalance" />
                  {{ 'showBalance' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showBalanceDescription' | translate }}</span>
              </div>
              <div class="fv2-export-toggle-item">
                <label class="fv2-checkbox-row">
                  <input type="checkbox" [disabled]="cfdStandardOption" [(ngModel)]="cfdShowReceived" />
                  {{ 'showReceived' | translate }}
                </label>
                <span class="fv2-export-toggle-hint"><i class="ph ph-info"></i>{{ 'showReceivedDescription' | translate }}</span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="cfdDownloadPendingReport">
            <div class="fv2-export-section-label">{{ 'studentFilter' | translate }}</div>
            <div class="fv2-field-row">
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="cfdPendingActiveFilter" />
                {{ 'activeStudent' | translate }}
              </label>
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="cfdPendingDeactiveFilter" />
                {{ 'deactiveStudent' | translate }}
              </label>
            </div>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-primary" (click)="exportClassFeeDetailToExcel()">
            <i class="ph ph-file-xls"></i><span>{{ 'exportReportExcel' | translate }}</span>
          </button>
          <button type="button" class="fv2-btn-ghost" (click)="exportClassFeeDetailToPrint()">
            <i class="ph ph-printer"></i><span>{{ 'printReportExcel' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Export popup — ports FeesManagementComponent's
         standardFeeExportPopUp (openStandardFeeExportPopUp()/
         exportStandardFeeDetailsToExcel()/exportStandardFeeDetailsToPrint(),
         ts:1195-1340) against the SAME already-loaded breakdown data,
         restyled in the fv2-* modal language. -->
    <div class="fv2-modal-backdrop" *ngIf="standardFeeExportPopupOpen" (click)="closeStandardFeeExportPopup()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'optionExport' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeStandardFeeExportPopup()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body" style="display:flex; gap:12px;">
          <button type="button" class="fv2-btn-primary" style="flex:1; justify-content:center;" (click)="exportStandardFeeDetailsToExcel()">
            <i class="ph ph-file-xls"></i><span>{{ 'exportReportExcel' | translate }}</span>
          </button>
          <button type="button" class="fv2-btn-ghost" style="flex:1; justify-content:center;" (click)="exportStandardFeeDetailsToPrint()">
            <i class="ph ph-printer"></i><span>{{ 'printReportExcel' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Placeholder shells — not ported from the old FeesManagementComponent
       yet; out of scope for this v2 Overview-only pass. -->
  <!-- Fees Board tab — ports FeesManagementComponent's #feeboard tab-pane
       1:1 against the same feeService endpoints (see feesmanage-v2.
       component.ts for scope notes: dead/orphaned old-component markup is
       NOT ported). 7 sub-tabs. -->
  <ng-container *ngIf="activeTab === 'feesBoard'">
    <div class="fv2-subtabs">
      <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="feesBoardSubTab === 'standards'" (click)="setFeesBoardSubTab('standards')">{{ 'standards' | translate }}</button>
      <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="feesBoardSubTab === 'structures'" (click)="setFeesBoardSubTab('structures')">{{ 'feeStructure' | translate }}</button>
      <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="feesBoardSubTab === 'categories'" (click)="setFeesBoardSubTab('categories')">{{ 'studentCategories' | translate }}</button>
      <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="feesBoardSubTab === 'components'" (click)="setFeesBoardSubTab('components')">{{ 'feesComponents' | translate }}</button>
      <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="feesBoardSubTab === 'terms'" (click)="setFeesBoardSubTab('terms')">{{ 'termComponent' | translate }}</button>
      <button type="button" class="fv2-subtab" *ngIf="canSeeLateFeeSubTab" [class.fv2-subtab-active]="feesBoardSubTab === 'lateFees'" (click)="setFeesBoardSubTab('lateFees')">{{ 'lateFee' | translate }}</button>
      <button type="button" class="fv2-subtab" *ngIf="canSeeOtherFeesSubTab" [class.fv2-subtab-active]="feesBoardSubTab === 'otherFees'" (click)="setFeesBoardSubTab('otherFees')">{{ 'otherFees' | translate }}</button>
    </div>

    <!-- ===== Standards (view/edit board) ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'standards'">
      <div class="fv2-details-head">
        <h3>{{ 'standards' | translate }}</h3>
      </div>
      <div class="fv2-empty" *ngIf="!fbStandardsRequested">
        <span class="fv2-em-icon"><i class="ph ph-kanban"></i></span>
        <b>{{ 'toView/editFeeConfigPlease' | translate }}</b>
        <button type="button" class="fv2-btn-primary" style="margin-top:12px;" (click)="fbShowStandards()">{{ 'clickHere' | translate }}</button>
      </div>
      <div class="fv2-empty" *ngIf="fbStandardsRequested && fbStandardsLoading && fbStandards.length === 0">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="fbStandardsRequested && !fbStandardsLoading && fbStandards.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-kanban"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <!-- One column per fee structure, each showing whether that
           structure's amounts are already configured for the class —
           ports the old component's per-structure check/cross indicator
           (feesmanage.component.html:346-351) exactly, restyled with
           Phosphor icons instead of FontAwesome for consistency with the
           rest of this v2 page. -->
      <div class="fv2-wrap" *ngIf="fbStandardsRequested && fbStandards.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'manage' | translate }}</th>
              <th>{{ 'class' | translate }}</th>
              <th *ngFor="let str of fbStandardsStrList">{{ str.Name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of fbStandards" [rowEntrance]="row.classId">
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openFeeBoard(row)" [attr.aria-label]="'manage' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
              </td>
              <td class="fv2-money">{{ row.classNumber }} - {{ row.classDivision }}</td>
              <td *ngFor="let str of fbStandardsStrList">
                <i *ngIf="fbStandardStructureFor(row, str.Name)?.isConfigured === 'YES'" class="ph ph-check-circle fv2-fb-configured" [title]="'configured' | translate"></i>
                <i *ngIf="fbStandardStructureFor(row, str.Name)?.isConfigured !== 'YES'" class="ph ph-x-circle fv2-fb-not-configured" [title]="'notConfigured' | translate"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fv2-pager-row" *ngIf="fbStandardsRequested && fbStandardsMaxPage > 1">
        <button type="button" class="fv2-btn-ghost" [disabled]="fbStandardsPage <= 1 || fbStandardsLoading" (click)="fbStandardsGo(fbStandardsPage - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
        <button type="button" *ngFor="let n of fbStandardsPageList" [class.fv2-btn-primary]="n === fbStandardsPage" [class.fv2-btn-ghost]="n !== fbStandardsPage" [disabled]="fbStandardsLoading" (click)="fbStandardsGo(n)">{{ n }}</button>
        <button type="button" class="fv2-btn-ghost" [disabled]="fbStandardsPage >= fbStandardsMaxPage || fbStandardsLoading" (click)="fbStandardsGo(fbStandardsPage + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
      </div>
    </div>

    <!-- ===== Fee Structure ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'structures'">
      <div class="fv2-details-head">
        <h3>{{ 'feeStructure' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openCreateFeeStructure()">
          <i class="ph ph-plus"></i><span>{{ 'addNewStructure' | translate }}</span>
        </button>
      </div>
      <div class="fv2-empty" *ngIf="fbStructuresLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!fbStructuresLoading && fbStructureList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-stack"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-list-search" *ngIf="fbStructureList.length > 0">
        <i class="ph ph-magnifying-glass"></i>
        <input type="text" class="fv2-field-input" [(ngModel)]="fbSearch['struct']" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
      </div>
      <div class="fv2-wrap" *ngIf="fbStructureList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'name' | translate }}</th>
              <th>{{ 'appliesTo' | translate }}</th>
              <th>{{ 'manage' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let structure of fbPaged(fbStructureList, 'struct')" [rowEntrance]="structure.pkFeeStructuresId">
              <td class="fv2-money">{{ structure.Name }}</td>
              <td>{{ structure.appliesTo }}</td>
              <td>
                <button *ngIf="structure.isEditable != false" type="button" class="fv2-row-icon-btn" (click)="openEditFeeStructure(structure)" [attr.aria-label]="'edit' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fv2-pager-row" *ngIf="fbListPages(fbStructureList, 'struct') > 1">
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['struct'] <= 1" (click)="fbListGo(fbStructureList, 'struct', fbListPage['struct'] - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
        <button type="button" *ngFor="let n of fbListPageNumbers(fbStructureList, 'struct')" [class.fv2-btn-primary]="n === fbListPage['struct']" [class.fv2-btn-ghost]="n !== fbListPage['struct']" (click)="fbListGo(fbStructureList, 'struct', n)">{{ n }}</button>
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['struct'] >= fbListPages(fbStructureList, 'struct')" (click)="fbListGo(fbStructureList, 'struct', fbListPage['struct'] + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
      </div>
    </div>

    <!-- ===== Student category: assign / move students ===== -->
    <div class="fv2-modal-backdrop" *ngIf="fbAssignOpen" (click)="closeAssignStudentsToCategory()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'fv2AssignStudents' | translate }} — {{ fbAssignCategory?.Name }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeAssignStudentsToCategory()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <h4 class="fv2-subhead">{{ 'fv2AddStudents' | translate }}</h4>
          <div class="fv2-field-row" style="align-items:flex-end;">
            <div style="width:200px;">
              <label class="fv2-field-label">{{ 'class' | translate }}</label>
              <select class="fv2-field-input" [(ngModel)]="fbAssignClassId" [ngModelOptions]="{standalone: true}">
                <option value="0">{{ 'all' | translate }}</option>
                <option *ngFor="let c of fbClassListOfSchool" [value]="c.classId">{{ c.classNumber }} - {{ c.classDivision }}</option>
              </select>
            </div>
            <div style="flex:1;">
              <label class="fv2-field-label">{{ 'searchStudent' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fbAssignQuery" [ngModelOptions]="{standalone: true}" (keyup.enter)="fbSearchStudentsToAssign()" [placeholder]="'fv2SearchByStudentName' | translate" />
            </div>
            <button type="button" class="fv2-btn-primary" style="height:38px;" [disabled]="fbAssignSearching" (click)="fbSearchStudentsToAssign()">
              <i class="ph ph-magnifying-glass"></i><span>{{ 'search' | translate }}</span>
            </button>
          </div>
          <div class="fv2-wrap" style="margin-top:12px;" *ngIf="fbAssignResults.length > 0">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th><label class="fv2-checkbox-row" style="margin:0;"><input type="checkbox" [(ngModel)]="fbAssignSelectAll" [ngModelOptions]="{standalone: true}" (ngModelChange)="fbToggleAssignAll($event)" /> {{ 'selectAll' | translate }}</label></th>
                  <th>{{ 'name' | translate }}</th>
                  <th>{{ 'parent' | translate }}</th>
                  <th>{{ 'class' | translate }}</th>
                  <th>{{ 'mobile' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of fbAssignResults">
                  <td>
                    <span *ngIf="s.paidFees > 0" class="fv2-muted-note">{{ 'fv2NotAllowedFeesCollected' | translate }}</span>
                    <input *ngIf="!(s.paidFees > 0)" type="checkbox" [(ngModel)]="s.selected" [ngModelOptions]="{standalone: true}" />
                  </td>
                  <td class="fv2-money">{{ s.studentName }}</td>
                  <td>{{ s.parentName }}</td>
                  <td>{{ s.classNumber }} - {{ s.classDivision }}</td>
                  <td>{{ s.mobileNumber }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="margin-top:12px;" *ngIf="fbAssignSelectedCount > 0">
            <button type="button" class="fv2-btn-primary" [disabled]="fbAssignSaving" (click)="fbAssignSelected()">
              <i class="ph ph-user-plus"></i><span>{{ 'assign' | translate }} {{ fbAssignSelectedCount }}</span>
            </button>
          </div>

          <h4 class="fv2-subhead" style="margin-top:24px;">{{ 'fv2StudentsInCategory' | translate }} ({{ fbMemberTotal }})</h4>
          <div class="fv2-list-search" style="margin:0 0 12px;">
            <i class="ph ph-magnifying-glass"></i>
            <input type="text" class="fv2-field-input" [(ngModel)]="fbMemberSearch" [ngModelOptions]="{standalone: true}" (keyup.enter)="fbMemberSearchChanged()" (blur)="fbMemberSearchChanged()" [placeholder]="'tv2Search' | translate" />
          </div>
          <div class="fv2-wrap">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'name' | translate }}</th>
                  <th>{{ 'parent' | translate }}</th>
                  <th>{{ 'class' | translate }}</th>
                  <th>{{ 'mobile' | translate }}</th>
                  <th>{{ 'manage' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="fbMemberLoading"><td colspan="5" class="fv2-empty-cell"><i class="ph ph-circle-notch fv2-spin"></i></td></tr>
                <tr *ngIf="!fbMemberLoading && fbMemberRows.length === 0"><td colspan="5" class="fv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                <tr *ngFor="let m of fbMemberRows">
                  <td class="fv2-money">{{ m.studentName }}</td>
                  <td>{{ m.parentName }}</td>
                  <td>{{ m.className }}</td>
                  <td>{{ m.mobileNumber }}</td>
                  <td>
                    <button type="button" class="fv2-row-icon-btn" (click)="fbOpenMoveStudent(m)" [attr.aria-label]="'move' | translate" [title]="'move' | translate"><i class="ph ph-arrows-left-right"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="fv2-pager-row" *ngIf="fbMemberTotal > fbMemberSize">
            <button type="button" class="fv2-btn-ghost" [disabled]="fbMemberPage <= 1" (click)="fbMemberGo(fbMemberPage - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
            <b>{{ fbMemberPage }} / {{ fbMemberPages }}</b>
            <button type="button" class="fv2-btn-ghost" [disabled]="fbMemberPage >= fbMemberPages" (click)="fbMemberGo(fbMemberPage + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeAssignStudentsToCategory()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <div class="fv2-modal-backdrop" *ngIf="fbMoveOpen" (click)="fbMoveOpen = false">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'move' | translate }} — {{ fbMoveStudent?.studentName }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fbMoveOpen = false"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'selectCategoryToMove' | translate }}</label>
          <select class="fv2-field-input" [(ngModel)]="fbMoveCategoryId" [ngModelOptions]="{standalone: true}">
            <option value="0">{{ 'default' | translate }}</option>
            <option *ngFor="let c of fbCategoryList" [value]="c.pkStudentsCategoryId">{{ c.Name }}</option>
          </select>
          <p class="fv2-hint" *ngIf="fbMoveCategoryId != fbAssignCategory?.pkStudentsCategoryId">{{ 'byMovingToAnotherCategoryItWillAffectStudentsFeeStructure' | translate }}</p>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" [disabled]="fbMoveSaving" (click)="fbMoveOpen = false">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" *ngIf="fbMoveCategoryId != fbAssignCategory?.pkStudentsCategoryId" [disabled]="fbMoveSaving" (click)="fbMoveStudentConfirm()">
            <i class="ph ph-circle-notch fv2-spin" *ngIf="fbMoveSaving"></i><span>{{ 'move' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ===== Student Categories ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'categories'">
      <div class="fv2-details-head">
        <h3>{{ 'studentCategories' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openCreateStudentCategory()">
          <i class="ph ph-plus"></i><span>{{ 'addNewCategory' | translate }}</span>
        </button>
      </div>
      <div class="fv2-empty" *ngIf="fbCategoriesLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!fbCategoriesLoading && fbCategoryList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-users-three"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-list-search" *ngIf="fbCategoryList.length > 0">
        <i class="ph ph-magnifying-glass"></i>
        <input type="text" class="fv2-field-input" [(ngModel)]="fbSearch['cat']" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
      </div>
      <div class="fv2-wrap" *ngIf="fbCategoryList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'name' | translate }}</th>
              <th>{{ 'students' | translate }}</th>
              <th>{{ 'manage' | translate }}</th>
              <th>{{ 'delete' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let category of fbPaged(fbCategoryList, 'cat')" [rowEntrance]="category.pkStudentsCategoryId">
              <td class="fv2-money">{{ category.Name }}</td>
              <td>{{ category.studentCount || 0 }}</td>
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openEditStudentCategory(category)" [attr.aria-label]="'edit' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
                <button type="button" class="fv2-row-icon-btn" (click)="openAssignStudentsToCategory(category)" [attr.aria-label]="'fv2AssignStudents' | translate" [title]="'fv2AssignStudents' | translate">
                  <i class="ph ph-user-plus"></i>
                </button>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn fv2-row-icon-btn-danger" [disabled]="category.collectedAmount > 0"
                  (click)="openDeleteStudentCategory(category)" [attr.aria-label]="'delete' | translate">
                  <i class="ph ph-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fv2-pager-row" *ngIf="fbListPages(fbCategoryList, 'cat') > 1">
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['cat'] <= 1" (click)="fbListGo(fbCategoryList, 'cat', fbListPage['cat'] - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
        <button type="button" *ngFor="let n of fbListPageNumbers(fbCategoryList, 'cat')" [class.fv2-btn-primary]="n === fbListPage['cat']" [class.fv2-btn-ghost]="n !== fbListPage['cat']" (click)="fbListGo(fbCategoryList, 'cat', n)">{{ n }}</button>
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['cat'] >= fbListPages(fbCategoryList, 'cat')" (click)="fbListGo(fbCategoryList, 'cat', fbListPage['cat'] + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
      </div>
    </div>

    <!-- ===== Fee Components ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'components'">
      <div class="fv2-details-head">
        <h3>{{ 'feesComponents' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openCreateFeeComponent()">
          <i class="ph ph-plus"></i><span>{{ 'addNewComponent' | translate }}</span>
        </button>
      </div>
      <div class="fv2-empty" *ngIf="fbComponentsLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!fbComponentsLoading && fbComponentList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-receipt"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-list-search" *ngIf="fbComponentList.length > 0">
        <i class="ph ph-magnifying-glass"></i>
        <input type="text" class="fv2-field-input" [(ngModel)]="fbSearch['comp']" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
      </div>
      <div class="fv2-wrap" *ngIf="fbComponentList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'feeName' | translate }}</th>
              <th>{{ 'dueDate' | translate }}</th>
              <th>{{ 'includeInTerm' | translate }}</th>
              <th>{{ 'appliesTo' | translate }}</th>
              <th>{{ 'manage' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let component of fbPaged(fbComponentList, 'comp')" [rowEntrance]="component.feesTypeId">
              <td class="fv2-money">{{ component.Name }}</td>
              <td>{{ component.includeInTerm === 1 ? '—' : (component.DueDate | date: 'dd-MMM-yyyy') }}</td>
              <td>{{ component.includeInTerm === 1 ? ('yes' | translate) : ('no' | translate) }}</td>
              <td>{{ component.AppliesTo }}</td>
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openEditFeeComponent(component)" [attr.aria-label]="'edit' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fv2-pager-row" *ngIf="fbListPages(fbComponentList, 'comp') > 1">
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['comp'] <= 1" (click)="fbListGo(fbComponentList, 'comp', fbListPage['comp'] - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
        <button type="button" *ngFor="let n of fbListPageNumbers(fbComponentList, 'comp')" [class.fv2-btn-primary]="n === fbListPage['comp']" [class.fv2-btn-ghost]="n !== fbListPage['comp']" (click)="fbListGo(fbComponentList, 'comp', n)">{{ n }}</button>
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['comp'] >= fbListPages(fbComponentList, 'comp')" (click)="fbListGo(fbComponentList, 'comp', fbListPage['comp'] + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
      </div>
    </div>

    <!-- ===== Terms ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'terms'">
      <div class="fv2-details-head">
        <h3>{{ 'termComponent' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openCreateTerm()">
          <i class="ph ph-plus"></i><span>{{ 'addNewTerm' | translate }}</span>
        </button>
      </div>
      <div class="fv2-empty" *ngIf="fbTermsLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!fbTermsLoading && fbTermList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-calendar"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-list-search" *ngIf="fbTermList.length > 0">
        <i class="ph ph-magnifying-glass"></i>
        <input type="text" class="fv2-field-input" [(ngModel)]="fbSearch['term']" [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
      </div>
      <div class="fv2-wrap" *ngIf="fbTermList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'termName' | translate }}</th>
              <th>{{ 'dueDate' | translate }}</th>
              <th>{{ 'manage' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let term of fbPaged(fbTermList, 'term')" [rowEntrance]="term.pkFeesTermId">
              <td class="fv2-money">{{ term.TermName }}</td>
              <td>{{ term.DueDate | date: 'dd-MMM-yyyy' }}</td>
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openEditTerm(term)" [attr.aria-label]="'edit' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fv2-pager-row" *ngIf="fbListPages(fbTermList, 'term') > 1">
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['term'] <= 1" (click)="fbListGo(fbTermList, 'term', fbListPage['term'] - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
        <button type="button" *ngFor="let n of fbListPageNumbers(fbTermList, 'term')" [class.fv2-btn-primary]="n === fbListPage['term']" [class.fv2-btn-ghost]="n !== fbListPage['term']" (click)="fbListGo(fbTermList, 'term', n)">{{ n }}</button>
        <button type="button" class="fv2-btn-ghost" [disabled]="fbListPage['term'] >= fbListPages(fbTermList, 'term')" (click)="fbListGo(fbTermList, 'term', fbListPage['term'] + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
      </div>
    </div>

    <!-- ===== Late Fees ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'lateFees'">
      <div class="fv2-details-head">
        <h3>{{ 'lateFee' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openCreateLateFee(null)">
          <i class="ph ph-plus"></i><span>{{ 'addNewLateFee' | translate }}</span>
        </button>
      </div>
      <div class="fv2-modal-body" style="padding-top:0;">
        <label class="fv2-checkbox-row">
          <input type="checkbox" [checked]="fbIsLateFeeIncludedInCurrentMonth" (click)="fbToggleLateFeeIncludedInCurrentMonth()" />
          {{ 'includeLateFeeInCurrentMonth' | translate }}
        </label>
      </div>
      <div class="fv2-empty" *ngIf="fbLateFeesLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!fbLateFeesLoading && fbLateFeeList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-clock-countdown"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-wrap" *ngIf="fbLateFeeList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'lateDays' | translate }}</th>
              <th>{{ 'lateFeeAmount' | translate }}</th>
              <th>{{ 'manage' | translate }}</th>
              <th>{{ 'delete' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let lf of fbLateFeeList" [rowEntrance]="lf.pkLateFeesId">
              <td class="fv2-money">{{ lf.lateDays }}</td>
              <td>{{ currencySymbol }}{{ lf.lateFees }}</td>
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openCreateLateFee(lf)" [attr.aria-label]="'edit' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn fv2-row-icon-btn-danger" (click)="openDeleteLateFee(lf)" [attr.aria-label]="'delete' | translate">
                  <i class="ph ph-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ===== Other Fees ===== -->
    <div class="fv2-panel" *ngIf="feesBoardSubTab === 'otherFees'">
      <div class="fv2-details-head">
        <h3>{{ 'otherFees' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openCreateOtherFee()">
          <i class="ph ph-plus"></i><span>{{ 'addNewOtherFee' | translate }}</span>
        </button>
      </div>
      <div class="fv2-empty" *ngIf="fbOtherFeesLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!fbOtherFeesLoading && fbOtherFeeList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-coin"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-wrap" *ngIf="fbOtherFeeList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'name' | translate }}</th>
              <th>{{ 'amount' | translate }}</th>
              <th>{{ 'students' | translate }}</th>
              <th>{{ 'terms' | translate }}</th>
              <th>{{ 'manage' | translate }}</th>
              <th>{{ 'delete' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let otherFee of fbOtherFeeList" [rowEntrance]="otherFee.pkOtherFeesId">
              <td class="fv2-money">{{ otherFee.Name }}</td>
              <td>{{ currencySymbol }}{{ otherFee.amount }}</td>
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openAssignStudentsToOtherFee(otherFee)" [attr.aria-label]="'assignStudents' | translate">
                  <i class="ph ph-users"></i>
                </button>
                <span style="margin-left:6px;">{{ otherFee.studentsCount || 0 }}</span>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn" (click)="openManageOtherFeeTerms(otherFee)" [attr.aria-label]="'terms' | translate">
                  <i class="ph ph-list-numbers"></i>
                </button>
                <span style="margin-left:6px;">{{ otherFee.numberOfTerms || 0 }}</span>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn" *ngIf="!(otherFee.collectedAmount > 0)" (click)="openEditOtherFee(otherFee)" [attr.aria-label]="'edit' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn fv2-row-icon-btn-danger" *ngIf="!(otherFee.collectedAmount > 0)" (click)="openDeleteOtherFee(otherFee)" [attr.aria-label]="'delete' | translate">
                  <i class="ph ph-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ====================== MODALS ====================== -->

    <!-- Fee Board amount-entry modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbBoardModalOpen" (click)="closeFeeBoardModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'feeBoard' | translate }} — {{ fbBoardClassLabel }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeFeeBoardModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-field-row" style="align-items:center;" *ngIf="fbBoardCopyClassList.length > 0">
            <select class="fv2-field-input" style="width:auto;" [(ngModel)]="fbBoardCopyFromClassId">
              <option [ngValue]="null">{{ 'copyFromAnotherClass' | translate }}</option>
              <option *ngFor="let c of fbBoardCopyClassList" [ngValue]="c.classId">{{ c.ClassNumber }} - {{ c.classDivision }}</option>
            </select>
            <button type="button" class="fv2-btn-ghost" [disabled]="!fbBoardCopyFromClassId" (click)="fbCopyBoardFromClass()">{{ 'copy' | translate }}</button>
          </div>

          <div class="fv2-empty" *ngIf="fbBoardLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>

          <!-- Single table, one row per fee structure — ports the old
               component's #selectedFeeDtail table layout exactly
               (feesmanage.component.html:4776-4822): Term Config icon +
               Structure Name + History icon as leading columns, then one
               amount-input column per fee type, instead of the previous
               per-structure "card" layout. -->
          <div class="fv2-wrap" *ngIf="!fbBoardLoading && fbBoardData.length > 0">
            <table class="fv2-table fv2-board-table">
              <thead>
                <tr>
                  <th>{{ 'termConfig' | translate }}</th>
                  <th>{{ 'structureName' | translate }}</th>
                  <th>{{ 'history' | translate }}</th>
                  <th *ngFor="let feeName of fbBoardData[0]?.feeTypes">{{ feeName.Name }} ({{ currencySymbol }})</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let structure of fbBoardData">
                  <td>
                    <button type="button" class="fv2-row-icon-btn" (click)="openTermFeeConfig(structure)" [attr.aria-label]="'termConfiguration' | translate">
                      <i class="ph ph-table"></i>
                    </button>
                  </td>
                  <td class="fv2-money">{{ structure.Name }}</td>
                  <td>
                    <button type="button" class="fv2-row-icon-btn" (click)="openFeeBoardHistory(structure)" [attr.aria-label]="'history' | translate">
                      <i class="ph ph-clock-counter-clockwise"></i>
                    </button>
                  </td>
                  <td *ngFor="let type of structure.feeTypes">
                    <input type="number" min="0" class="fv2-field-input fv2-board-cell-input" [(ngModel)]="type.Amount" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="fv2-empty" *ngIf="!fbBoardLoading && fbBoardData.length === 0">
            <b>{{ 'noDataAvailableInTable' | translate }}</b>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeFeeBoardModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbBoardSaving" (click)="saveFeeBoard()">
            {{ fbBoardSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Fee Board history modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbBoardHistoryOpen" (click)="closeFeeBoardHistory()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'history' | translate }} — {{ fbBoardHistoryStructureName }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeFeeBoardHistory()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="fbBoardHistoryLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <div class="fv2-wrap" *ngIf="!fbBoardHistoryLoading">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'modifiedBy' | translate }}</th>
                  <th>{{ 'feesCategory' | translate }}</th>
                  <th>{{ 'originalValue' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'newValue' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'modifiedDate' | translate }}</th>
                </tr>
              </thead>
              <tbody *ngIf="fbBoardHistoryList.length > 0; else fv2NoBoardHistory">
                <tr *ngFor="let h of fbBoardHistoryList">
                  <td>{{ h.username }}</td>
                  <td class="fv2-money">{{ h.TermName }}</td>
                  <td>{{ h.OldValue }}</td>
                  <td>{{ h.NewValue }}</td>
                  <td>{{ h.CreatedTime | date: 'dd-MMM-yyyy hh:mm a' }}</td>
                </tr>
              </tbody>
              <ng-template #fv2NoBoardHistory>
                <tbody><tr><td colspan="5">{{ 'noDataAvailableInTable' | translate }}</td></tr></tbody>
              </ng-template>
            </table>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeFeeBoardHistory()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Term Fee Configuration matrix modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbTermConfigModalOpen" (click)="closeTermFeeConfigModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'termConfiguration' | translate }} — {{ fbTermConfigStructureName }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeTermFeeConfigModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-field-row" style="align-items:center;" *ngIf="fbBoardCopyClassList.length > 0">
            <select class="fv2-field-input" style="width:auto;" [(ngModel)]="fbTermConfigCopyFromClassId">
              <option [ngValue]="null">{{ 'copyFromAnotherClass' | translate }}</option>
              <option *ngFor="let c of fbBoardCopyClassList" [ngValue]="c.classId">{{ c.ClassNumber }} - {{ c.classDivision }}</option>
            </select>
            <button type="button" class="fv2-btn-ghost" [disabled]="!fbTermConfigCopyFromClassId" (click)="fbCopyTermConfigFromClass()">{{ 'copy' | translate }}</button>
          </div>

          <div class="fv2-empty" *ngIf="fbTermConfigLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>

          <div class="fv2-wrap" *ngIf="!fbTermConfigLoading && fbTermConfigurations.length > 0">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'feeName' | translate }}</th>
                  <th>{{ 'amount' | translate }}</th>
                  <th *ngFor="let term of fbTermConfigTermList">{{ term.TermName }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let config of fbTermConfigurations">
                  <td class="fv2-money">{{ config.Name }}</td>
                  <td>{{ currencySymbol }}{{ config.Amount }}</td>
                  <td *ngFor="let term of fbTermConfigTermList">
                    <input type="number" class="fv2-field-input" style="min-width:90px;"
                      [ngModel]="fbFindTermFee(config, term.pkFeesTermId)?.PaymentAmount"
                      (ngModelChange)="fbSetTermFeeAmount(config, term.pkFeesTermId, $event)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="fv2-empty" *ngIf="!fbTermConfigLoading && fbTermConfigurations.length === 0">
            <b>{{ 'noDataAvailableInTable' | translate }}</b>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeTermFeeConfigModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbTermConfigSaving" (click)="saveTermFeeConfig()">
            {{ fbTermConfigSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Fee Structure create/edit modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbStructureModalOpen" (click)="closeFeeStructureModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fbStructureForm.feeStructureId ? ('editStructure' | translate) : ('addNewStructure' | translate) }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeFeeStructureModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'name' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbStructureForm.name" />

          <label class="fv2-field-label">{{ 'appliesTo' | translate }} ({{ 'studentCategories' | translate }})</label>
          <select class="fv2-field-input" [(ngModel)]="fbStructureForm.studentCategoryId">
            <option value="" disabled>{{ 'select' | translate }}</option>
            <option *ngFor="let c of fbStudentCategoryListForSelect" [ngValue]="c.pkStudentsCategoryId">{{ c.Name }}</option>
          </select>

          <label class="fv2-field-label">{{ 'description' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbStructureForm.description" maxlength="300" />
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeFeeStructureModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbStructureSaving" (click)="saveFeeStructure()">
            {{ fbStructureSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Student Category create/edit modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbCategoryModalOpen" (click)="closeStudentCategoryModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fbCategoryForm.studentCategoryId ? ('editCategory' | translate) : ('addNewCategory' | translate) }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeStudentCategoryModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'name' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbCategoryForm.name" />
          <label class="fv2-field-label">{{ 'description' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbCategoryForm.description" maxlength="300" />
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeStudentCategoryModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbCategorySaving" (click)="saveStudentCategory()">
            {{ fbCategorySaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Delete Student Category confirm -->
    <div class="fv2-modal-backdrop" *ngIf="fbDeleteCategoryModalOpen" (click)="closeDeleteStudentCategory()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-body" style="text-align:center;">
          <h4>{{ 'areYouConfirmToDelete' | translate }} <b><i>{{ fbDeleteCategoryTarget?.Name }}</i></b>?</h4>
        </div>
        <div class="fv2-modal-foot" style="justify-content:center;">
          <button type="button" class="fv2-btn-ghost" (click)="closeDeleteStudentCategory()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbDeleteCategorySaving" (click)="deleteStudentCategoryConfirm()">
            {{ fbDeleteCategorySaving ? ('pleaseWait' | translate) : ('delete' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Fee Component create/edit modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbComponentModalOpen" (click)="closeFeeComponentModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fbComponentForm.feesTypeId ? ('editComponent' | translate) : ('addNewComponent' | translate) }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeFeeComponentModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'name' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbComponentForm.Name" />

          <label class="fv2-checkbox-row" style="margin-top:14px;">
            <input type="checkbox" [(ngModel)]="fbComponentForm.includeInTerm" [disabled]="!!fbComponentForm.feesTypeId" />
            {{ 'includeInTerm' | translate }}
          </label>

          <ng-container *ngIf="!fbComponentForm.includeInTerm">
            <label class="fv2-field-label">{{ 'dueDate' | translate }}</label>
            <input type="date" class="fv2-field-input" [(ngModel)]="fbComponentForm.duedate" />
          </ng-container>

          <label class="fv2-field-label">{{ 'appliesTo' | translate }}</label>
          <select class="fv2-field-input" [(ngModel)]="fbComponentForm.AppliesTo" [disabled]="!!fbComponentForm.feesTypeId">
            <option value="ALL_STUDENTS">{{ 'allStudents' | translate }}</option>
            <option value="NEW_STUDENTS">{{ 'newStudents' | translate }}</option>
            <option value="OLD_STUDENTS">{{ 'oldStudents' | translate }}</option>
            <option value="BUS_FACILITY_STUDENTS">{{ 'busFacilityStudents' | translate }}</option>
          </select>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeFeeComponentModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbComponentSaving" (click)="saveFeeComponent()">
            {{ fbComponentSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Term create/edit modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbTermModalOpen" (click)="closeTermModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fbTermForm.pkFeesTermId ? ('editTerm' | translate) : ('addNewTerm' | translate) }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeTermModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'termName' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbTermForm.TermName" />
          <label class="fv2-field-label">{{ 'dueDate' | translate }}</label>
          <input type="date" class="fv2-field-input" [(ngModel)]="fbTermForm.DueDate" />
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeTermModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbTermSaving" (click)="saveTerm()">
            {{ fbTermSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Late Fee create/edit modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbLateFeeModalOpen" (click)="closeLateFeeModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fbSelectedLateFeesId ? ('editLateFee' | translate) : ('addNewLateFee' | translate) }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeLateFeeModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="fbLateFeeLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <ng-container *ngIf="!fbLateFeeLoading">
            <div class="fv2-field-row">
              <div style="flex:1;">
                <label class="fv2-field-label">{{ 'lateDays' | translate }}</label>
                <input type="number" class="fv2-field-input" [(ngModel)]="fbLateFeesDays" />
              </div>
              <div style="flex:1;">
                <label class="fv2-field-label">{{ 'lateFeeAmount' | translate }}</label>
                <input type="number" class="fv2-field-input" [(ngModel)]="fbLateFeesAmount" />
              </div>
            </div>

            <label class="fv2-checkbox-row" style="margin:14px 0;">
              <input type="checkbox" [(ngModel)]="fbSelectAllFees" (ngModelChange)="fbOnSelectAllFeesChange()" />
              <b>{{ 'selectAllFees' | translate }}</b>
            </label>

            <ng-container *ngIf="fbFeesList.length > 0">
              <label class="fv2-field-label">{{ 'termFees' | translate }}</label>
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="fbSelectAllTermFees" (ngModelChange)="fbOnSelectAllTermFeesChange()" />
                {{ 'selectAll' | translate }}
              </label>
              <div class="fv2-latefee-tree">
                <div *ngFor="let fee of fbFeesList; let i = index" class="fv2-latefee-tree-row">
                  <label class="fv2-checkbox-row">
                    <input type="checkbox" [(ngModel)]="fee.isFeeSelected" (ngModelChange)="fbCheckSelectAllStatus()" />
                    <span>{{ fee.feeTermName }}</span>
                  </label>
                  <i *ngIf="fee.termFeeList?.length" class="ph" [ngClass]="fbExpandedItems[i] ? 'ph-caret-up' : 'ph-caret-down'" (click)="fbExpandItem(i)"></i>
                  <div *ngIf="fbExpandedItems[i]" class="fv2-latefee-tree-sub">
                    <label class="fv2-checkbox-row" *ngFor="let t of fee.termFeeList">
                      <input type="checkbox" [(ngModel)]="fee.isFeeSelected" (ngModelChange)="fbOnFeeTermChange(fee)" />
                      <span>{{ t.feeTypeName }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="fbTermFeeList.length > 0">
              <label class="fv2-field-label">{{ 'typeFees' | translate }}</label>
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="fbSelectAllTypeFees" (ngModelChange)="fbOnSelectAllTypeFeesChange()" />
                {{ 'selectAll' | translate }}
              </label>
              <div class="fv2-latefee-tree">
                <label class="fv2-checkbox-row" *ngFor="let fee of fbTermFeeList" style="padding:4px 0;">
                  <input type="checkbox" [(ngModel)]="fee.isFeeSelected" (ngModelChange)="fbCheckSelectAllStatus()" />
                  <span>{{ fee.feeTypeName }}</span>
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="fbTransportList.length > 0">
              <label class="fv2-field-label" [class.fv2-disabled-text]="fbIncludeLateFeeInTransportFee === 0">{{ 'transportFees' | translate }}</label>
              <div class="fv2-disabled-info" *ngIf="fbIncludeLateFeeInTransportFee === 0">
                <i class="ph ph-info"></i><span>{{ 'transportFeeSelectionDisabled' | translate }}</span>
              </div>
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="fbSelectAllTransportFees" [disabled]="fbIncludeLateFeeInTransportFee === 0" (ngModelChange)="fbOnSelectAllTransportFeesChange()" />
                {{ 'selectAll' | translate }}
              </label>
              <div class="fv2-latefee-tree" [class.fv2-disabled-text]="fbIncludeLateFeeInTransportFee === 0">
                <label class="fv2-checkbox-row" *ngFor="let fee of fbTransportList" style="padding:4px 0;">
                  <input type="checkbox" [(ngModel)]="fee.isFeeSelected" [disabled]="fbIncludeLateFeeInTransportFee === 0" (ngModelChange)="fbCheckSelectAllStatus()" />
                  <span>{{ fee.busStopTermName }}</span>
                </label>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeLateFeeModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbLateFeeSaving" (click)="saveLateFee()">
            {{ fbLateFeeSaving ? ('pleaseWait' | translate) : (fbSelectedLateFeesId ? ('update' | translate) : ('add' | translate)) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Delete Late Fee confirm -->
    <div class="fv2-modal-backdrop" *ngIf="fbDeleteLateFeeModalOpen" (click)="closeDeleteLateFee()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-body" style="text-align:center;">
          <h4>{{ 'areYouConfirmToDelete' | translate }} {{ 'lateFee' | translate }}?</h4>
        </div>
        <div class="fv2-modal-foot" style="justify-content:center;">
          <button type="button" class="fv2-btn-ghost" (click)="closeDeleteLateFee()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbDeleteLateFeeSaving" (click)="deleteLateFeeConfirm()">
            {{ fbDeleteLateFeeSaving ? ('pleaseWait' | translate) : ('delete' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Other Fee create/edit modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbOtherFeeModalOpen" (click)="closeOtherFeeModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fbOtherFeeForm.pkOtherFeesId ? ('editOtherFee' | translate) : ('addNewOtherFee' | translate) }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeOtherFeeModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'name' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="fbOtherFeeForm.name" />
          <label class="fv2-field-label">{{ 'amount' | translate }}</label>
          <input type="number" class="fv2-field-input" [(ngModel)]="fbOtherFeeForm.amount" />
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeOtherFeeModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbOtherFeeSaving" (click)="saveOtherFee()">
            {{ fbOtherFeeSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Delete Other Fee confirm -->
    <div class="fv2-modal-backdrop" *ngIf="fbDeleteOtherFeeModalOpen" (click)="closeDeleteOtherFee()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-body" style="text-align:center;">
          <h4>{{ 'areYouConfirmToDelete' | translate }} <b><i>{{ fbDeleteOtherFeeTarget?.Name }}</i></b>?</h4>
        </div>
        <div class="fv2-modal-foot" style="justify-content:center;">
          <button type="button" class="fv2-btn-ghost" (click)="closeDeleteOtherFee()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbDeleteOtherFeeSaving" (click)="deleteOtherFeeConfirm()">
            {{ fbDeleteOtherFeeSaving ? ('pleaseWait' | translate) : ('delete' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Manage Other Fee Terms modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbOtherFeeTermsModalOpen" (click)="closeOtherFeeTermsModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'manageTerms' | translate }} — {{ fbOtherFeeTermsTarget?.Name }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeOtherFeeTermsModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div *ngFor="let row of fbOtherFeeTermsList; let i = index" class="fv2-field-row" style="align-items:flex-end; margin-bottom:10px;">
            <div style="flex:1;">
              <label class="fv2-field-label">{{ 'termName' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="row.termName" />
            </div>
            <div style="flex:1;">
              <label class="fv2-field-label">{{ 'amount' | translate }}</label>
              <input type="number" class="fv2-field-input" [(ngModel)]="row.termAmount" [disabled]="row.paidAmount > 0" />
            </div>
            <div style="flex:1;">
              <label class="fv2-field-label">{{ 'dueDate' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="row.termDueDate" />
            </div>
            <button type="button" class="fv2-row-icon-btn fv2-row-icon-btn-danger" [disabled]="row.paidAmount > 0 || fbOtherFeeTermsList.length <= 1"
              (click)="removeOtherFeeTermRow(i)">
              <i class="ph ph-trash"></i>
            </button>
          </div>
          <button type="button" class="fv2-btn-ghost" (click)="addOtherFeeTermRow()">
            <i class="ph ph-plus"></i><span>{{ 'addTerm' | translate }}</span>
          </button>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeOtherFeeTermsModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbOtherFeeTermsSaving" (click)="saveOtherFeeTerms()">
            {{ fbOtherFeeTermsSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Assign Students to Other Fee modal -->
    <div class="fv2-modal-backdrop" *ngIf="fbAssignOtherFeeModalOpen" (click)="closeAssignOtherFeeModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'assignStudents' | translate }} — {{ fbAssignOtherFeeTarget?.Name }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeAssignOtherFeeModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-subtabs" style="margin-bottom:14px;">
            <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="fbAssignOtherFeeTab === 'add'" (click)="setAssignOtherFeeTab('add')">{{ 'addStudents' | translate }}</button>
            <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="fbAssignOtherFeeTab === 'existing'" (click)="setAssignOtherFeeTab('existing')">{{ 'existingStudents' | translate }}</button>
          </div>

          <ng-container *ngIf="fbAssignOtherFeeTab === 'add'">
            <div class="fv2-field-row" style="align-items:center;">
              <select class="fv2-field-input" style="width:auto;" [(ngModel)]="fbAssignOtherFeeSearchClassId">
                <option [ngValue]="null">{{ 'selectClass' | translate }}</option>
                <option *ngFor="let c of fbClassListOfSchool" [ngValue]="c.classId">{{ c.classNumber }} - {{ c.classDivision }}</option>
              </select>
              <input type="text" class="fv2-field-input" style="flex:1;" [(ngModel)]="fbAssignOtherFeeSearchText" [placeholder]="'searchStudent' | translate" />
              <button type="button" class="fv2-btn-primary" (click)="searchStudentForOtherFee()">{{ 'search' | translate }}</button>
            </div>
            <div class="fv2-wrap" style="margin-top:14px;" *ngIf="fbAssignOtherFeeStudentList.length > 0">
              <table class="fv2-table">
                <thead>
                  <tr>
                    <th><input type="checkbox" (change)="selectAllOtherFeeStudents($event.target.checked)" /></th>
                    <th>{{ 'studentName' | translate }}</th>
                    <th>{{ 'registrationNumber' | translate }}</th>
                    <th>{{ 'class' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of fbAssignOtherFeeStudentList">
                    <td><input type="checkbox" [(ngModel)]="s.select" /></td>
                    <td>{{ s.studentName }}</td>
                    <td>{{ s.registrationId }}</td>
                    <td>{{ s.className }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <ng-container *ngIf="fbAssignOtherFeeTab === 'existing'">
            <div class="fv2-wrap" *ngIf="fbAssignOtherFeeExistingList.length > 0; else fv2NoExistingOtherFeeStudents">
              <table class="fv2-table">
                <thead>
                  <tr>
                    <th>{{ 'studentName' | translate }}</th>
                    <th>{{ 'registrationNumber' | translate }}</th>
                    <th>{{ 'class' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of fbAssignOtherFeeExistingList">
                    <td>{{ s.studentName }}</td>
                    <td>{{ s.registrationId }}</td>
                    <td>{{ s.className }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #fv2NoExistingOtherFeeStudents>
              <div class="fv2-empty"><b>{{ 'noDataAvailableInTable' | translate }}</b></div>
            </ng-template>
          </ng-container>
        </div>
        <div class="fv2-modal-foot" *ngIf="fbAssignOtherFeeTab === 'add'">
          <button type="button" class="fv2-btn-ghost" (click)="closeAssignOtherFeeModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fbAssignOtherFeeSaving" (click)="assignStudentsToOtherFee()">
            {{ fbAssignOtherFeeSaving ? ('pleaseWait' | translate) : ('assign' | translate) }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Fee Collection tab — ports FeesManagementComponent's
       searchStudent()/fetchFeeCollectionInfo()/getStudentFeeList()/
       makePayment()/proceedToPaymentMode()/proceedToPayment()/
       sendPaymentInfo()/getFeeReceipt()/getFeeCollectionHistory() 1:1
       against the same feeService endpoints, using Angular state instead
       of jQuery DOM reads (see feesmanage-v2.component.ts). -->
  <ng-container *ngIf="activeTab === 'feeCollection'">
    <!-- Collect / History / Reports — same three sections, with the same
         permission gates, as the old Fee Collection tab's sub-nav
         (feesmanage.component.html:696-712). -->
    <div class="fv2-subtabs">
      <button type="button" class="fv2-subtab" *ngIf="canCollectFees || canViewFeeCollectionHistory" [class.fv2-subtab-active]="fcSection === 'collect'" (click)="fcSetSection('collect')">{{ 'collect' | translate }}</button>
      <button type="button" class="fv2-subtab" *ngIf="canViewFeeCollectionHistory" [class.fv2-subtab-active]="fcSection === 'history'" (click)="fcSetSection('history')">{{ 'history' | translate }}</button>
      <button type="button" class="fv2-subtab" *ngIf="canViewFeeCollectionHistory" [class.fv2-subtab-active]="fcSection === 'reports'" (click)="fcSetSection('reports')">{{ 'reports' | translate }}</button>
    </div>

    <!-- Search -->
    <div class="fv2-panel" *ngIf="fcSection === 'collect' && fcIsSearchActive">
      <div class="fv2-details-head">
        <h3>{{ 'fv2FeeCollection' | translate }}</h3>
      </div>
      <div class="fv2-modal-body" style="padding-top:0;">
        <div class="fv2-field-row" style="align-items:flex-end;">
          <div style="flex:1;">
            <label class="fv2-field-label">{{ 'searchStudent' | translate }}</label>
            <input type="text" class="fv2-field-input" [(ngModel)]="fcSearchText"
              (keyup.enter)="fcSearchStudent()" [placeholder]="fcSearchPlaceholderKey | translate" />
          </div>
          <div style="width:170px;">
            <label class="fv2-field-label">{{ 'searchBy' | translate }}</label>
            <select class="fv2-field-input" [(ngModel)]="fcSearchBy">
              <option value="STUDENT_NAME">{{ 'studentName' | translate }}</option>
              <option value="REGISTRATION_ID">{{ 'registrationNumber' | translate }}</option>
              <option value="MOBILE_NUMBER">{{ 'mobileNo' | translate }}</option>
            </select>
          </div>
          <button type="button" class="fv2-btn-primary" style="height:38px;" (click)="fcSearchStudent()">
            <i class="ph ph-magnifying-glass"></i><span>{{ 'search' | translate }}</span>
          </button>
        </div>
        <label class="fv2-checkbox-row" style="margin-top:14px;">
          <input type="checkbox" [(ngModel)]="fcIsStudentDeactivated" />
          {{ 'includeDeactivatedStudents' | translate }}
        </label>

        <div class="fv2-wrap" style="margin-top:16px;" *ngIf="fcStudentList.length > 0">
          <table class="fv2-table">
            <thead>
              <tr>
                <th>{{ 'studentName' | translate }}</th>
                <th>{{ 'parentName' | translate }}</th>
                <th>{{ 'mobileNo' | translate }}</th>
                <th>{{ 'class' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let student of fcStudentList" style="cursor:pointer;" (click)="fcSelectStudent(student)" [rowEntrance]="student.studentId">
                <td class="fv2-money">{{ student.studentName }}</td>
                <td>{{ student.parentName }}</td>
                <td>{{ student.mobileNumber }}</td>
                <td>
                  {{ student.classNumber }} {{ student.classDivision }}
                  <i *ngIf="student.isLoading" class="ph ph-circle-notch fv2-spin"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Student selected: dashboard + wizard -->
    <ng-container *ngIf="fcSection === 'collect' && !fcIsSearchActive && fcStudentFeeDashDetails as dash">
      <div class="fv2-panel">
        <div class="fv2-details-head">
          <h3>
            <a class="fv2-student-link" [class.fv2-student-link-off]="!fcCanEditProfile" role="button"
              [attr.title]="fcCanEditProfile ? ('editStudentInfo' | translate) : null"
              (click)="fcOpenEditStudent()">{{ dash.student?.studentName }}</a>
            <i class="ph ph-pencil-simple fv2-student-edit-hint" *ngIf="fcCanEditProfile"></i>
          </h3>
          <div style="display:flex; gap:8px;">
            <button type="button" class="fv2-btn-ghost" *ngIf="canCollectFees || canViewFeeCollectionHistory" (click)="fcOpenHistory()">
              <i class="ph ph-clock-counter-clockwise"></i><span>{{ 'paymentHistory' | translate }}</span>
            </button>
            <button type="button" class="fv2-btn-ghost" (click)="fcResetSearch()">
              <i class="ph ph-arrow-left"></i><span>{{ 'newSearch' | translate }}</span>
            </button>
          </div>
        </div>
        <div class="fv2-modal-body" style="padding-top:0;">
          <div class="fv2-student-info">
            <div><span>{{ 'parentName' | translate }}</span><b>{{ dash.student?.parentName || '-' }}</b></div>
            <div><span>{{ 'class' | translate }}</span><b>{{ dash.student?.classNumber }}-{{ dash.student?.classDivision }}</b></div>
            <div><span>{{ 'fv2RollNo' | translate }}</span><b>{{ dash.student?.rollNumber || '-' }}</b></div>
            <div><span>{{ 'feeStructure' | translate }}</span><b>{{ dash.student?.feeStructureName || ('default' | translate) }}</b></div>
            <div><span>{{ 'mobileNo' | translate }}</span><b>{{ fcSelectedStudent?.mobileNumber || dash.student?.mobileNumber || '-' }}</b></div>
            <div>
              <span>{{ 'fv2BusStop' | translate }}</span>
              <b *ngIf="fcCanEditProfile"><a class="fv2-student-link fv2-link-blue" (click)="fcOpenEditStudent()">{{ fcSelectedStudent?.BusStopName || dash.student?.BusStopName || ('setTransport' | translate) }}</a></b>
              <b *ngIf="!fcCanEditProfile">{{ fcSelectedStudent?.BusStopName || '-' }}</b>
            </div>
            <div *ngIf="dash.student?.siblingsCount > 0">
              <span>{{ 'fv2Siblings' | translate }}</span><b>{{ dash.student.siblingsCount }}</b>
            </div>
          </div>
        </div>
      </div>

      <!-- Term fees / Other fees summary (same four figures the old screen showed) -->
      <div class="fv2-stats fv2-fee-summary">
        <div class="fv2-panel fv2-fee-summary-card">
          <div class="fv2-details-head"><h3>{{ 'termFees' | translate }}</h3></div>
          <dl class="fv2-fee-rows">
            <div><dt>{{ 'totalTermFees' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TermFees?.TermAmount || 0 }}</dd></div>
            <div><dt>{{ 'paid' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TermFees?.Paid || 0 }}</dd></div>
            <div><dt>{{ 'discount' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TermFees?.Discount || 0 }}</dd></div>
            <div class="fv2-fee-balance"><dt>{{ 'balance' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TermFees?.Balance || 0 }}</dd></div>
          </dl>
        </div>
        <div class="fv2-panel fv2-fee-summary-card">
          <div class="fv2-details-head"><h3>{{ 'otherFees' | translate }}</h3></div>
          <dl class="fv2-fee-rows">
            <div><dt>{{ 'totalOtherFees' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TypeFees?.FeeTypeAmount || 0 }}</dd></div>
            <div><dt>{{ 'paid' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TypeFees?.Paid || 0 }}</dd></div>
            <div><dt>{{ 'discount' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TypeFees?.Discount || 0 }}</dd></div>
            <div class="fv2-fee-balance"><dt>{{ 'balance' | translate }}</dt><dd>{{ currencySymbol }}{{ dash.TypeFees?.Balance || 0 }}</dd></div>
          </dl>
        </div>
      </div>

      <!-- Step 1: select fees -->
      <div class="fv2-panel" *ngIf="fcWizardStep === 'select' && canCollectFees">
        <div class="fv2-details-head">
          <h3>{{ 'feesComponents' | translate }}</h3>
        </div>
        <div class="fv2-wrap" *ngIf="fcFeeList.length > 0">
          <table class="fv2-table">
            <thead>
              <tr>
                <th></th>
                <th *ngIf="canUseOldFeeCollection">{{ 'isOldFee' | translate }}</th>
                <th>{{ 'feeName' | translate }}</th>
                <th>{{ 'type' | translate }}</th>
                <th>{{ 'dueDate' | translate }}</th>
                <th>{{ 'amount' | translate }}</th>
                <th>{{ 'discount' | translate }}</th>
                <th>{{ 'paid' | translate }}</th>
                <th>{{ 'balance' | translate }}</th>
                <th>{{ 'lateFee' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="fcOldFeeBalance !== 0">
                <td colspan="10" class="fv2-empty-cell" style="color:#E32C2C;">
                  {{ 'previousAcademic' | translate }} <b>({{ fcStudentFeeDashDetails.old_fee.old_year }})</b> {{ 'pendingFeeIs' | translate }}
                  <b>{{ currencySymbol }} {{ fcOldFeeBalance }}</b> {{ 'pleaseClick' | translate }}
                  <a style="text-decoration:underline;font-weight:700;cursor:pointer;color:var(--brand-primary-color);" (click)="fcSwitchAcademic(fcStudentFeeDashDetails.old_fee.old_ac_id)">{{ 'here' | translate }}</a>
                  {{ 'toCollect' | translate }}
                </td>
              </tr>
              <tr>
                <td colspan="10" class="fv2-empty-cell" style="color:#E32C2C;">
                  {{ 'click' | translate }}
                  <a style="text-decoration:underline;font-weight:700;cursor:pointer;color:var(--brand-primary-color);" (click)="fcFetchAllAcademicFees()">{{ 'here' | translate }} <i *ngIf="fcAllAcademicLoading" class="ph ph-circle-notch fv2-spin"></i></a>
                  {{ 'toSeeAllAcademicPendingFeeToCollect' | translate }}
                </td>
              </tr>

              <tr *ngFor="let item of fcFeeList" [rowEntrance]="item.termId || item.typeId">
                <td>
                  <input type="checkbox" *ngIf="item.Balance > 0" [checked]="item.selected" [disabled]="item.disabled" (click)="fcToggleFeeSelection(item, fcFeeList)" />
                </td>
                <td *ngIf="canUseOldFeeCollection">
                  <input type="checkbox" *ngIf="item.Balance > 0" [disabled]="!item.selected" [(ngModel)]="item.isOldFee" />
                </td>
                <td class="fv2-money">
                  <a *ngIf="fcFeeSettingEnabled && item.TermName && item.typename" class="fv2-student-link" role="button" [title]="'feeBreakup' | translate"
                    (click)="fcShowTermBreakup(item)">{{ item.isBusFee ? (item.termName + ' (' + item.Name + ')') : (item.Name || item.TermName) }}</a>
                  <ng-container *ngIf="!(fcFeeSettingEnabled && item.TermName && item.typename)">{{ item.isBusFee ? (item.termName + ' (' + item.Name + ')') : (item.Name || item.TermName) }}</ng-container>
                  <i *ngIf="item.feeFault" class="ph ph-warning-circle" style="color:#D1485A;" [title]="'thereIsADataIssueWithThisFeePleaseContactSupport' | translate"></i>
                </td>
                <td>{{ (item.isBusFee ? 'fv2TypeTransport' : (item.TermName ? 'fv2TypeTerm' : 'fv2TypeOther')) | translate }}</td>
                <td>{{ (item.DueDate || item.termDueDate) | date: 'dd-MMM-yyyy' }}</td>
                <td>{{ currencySymbol }}{{ item.Balance + (item.Paid || 0) + (item.Discount || item.discount || 0) }}</td>
                <td>{{ currencySymbol }}{{ item.Discount || item.discount || 0 }}</td>
                <td>{{ currencySymbol }}{{ item.Paid || 0 }}</td>
                <td class="fv2-money">{{ currencySymbol }}{{ item.Balance || 0 }}</td>
                <td>
                  <ng-container *ngIf="item.lateFee > 0">{{ currencySymbol }}{{ item.lateFee }}</ng-container>
                  <ng-container *ngIf="!(item.lateFee > 0)">—</ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-container *ngIf="fcOtherFeeList.length > 0">
          <div class="fv2-details-head" style="margin-top:12px;">
            <h3>{{ 'otherFees' | translate }}</h3>
          </div>
          <div class="fv2-wrap">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th></th>
                  <th *ngIf="canUseOldFeeCollection">{{ 'isOldFee' | translate }}</th>
                  <th>{{ 'feeName' | translate }}</th>
                  <th>{{ 'type' | translate }}</th>
                  <th>{{ 'amount' | translate }}</th>
                  <th>{{ 'balance' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of fcOtherFeeList" [rowEntrance]="item.pkOtherFeesId">
                  <td>
                    <input type="checkbox" *ngIf="item.Balance > 0" [checked]="item.selected" [disabled]="item.disabled" (click)="fcToggleFeeSelection(item, fcOtherFeeList)" />
                  </td>
                  <td *ngIf="canUseOldFeeCollection">
                    <input type="checkbox" *ngIf="item.Balance > 0" [disabled]="!item.selected" [(ngModel)]="item.isOldFee" />
                  </td>
                  <td class="fv2-money">{{ item.Name }}</td>
                  <td>{{ 'fv2TypeOtherTerm' | translate }}</td>
                  <td>{{ currencySymbol }}{{ item.Balance + (item.Paid || 0) }}</td>
                  <td class="fv2-money">{{ currencySymbol }}{{ item.Balance || 0 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <div class="fv2-empty" *ngIf="fcFeeList.length === 0 && fcOtherFeeList.length === 0">
          <span class="fv2-em-icon"><i class="ph ph-check-circle"></i></span>
          <b>{{ 'noPendingFees' | translate }}</b>
        </div>

        <div class="fv2-modal-foot" *ngIf="fcTotalSelectedAmount > 0" style="border-top:1px solid #EEF0F2;">
          <div style="flex:1; font-size:13px; font-weight:700; color:#232323;">
            {{ 'totalSelected' | translate }}: {{ currencySymbol }}{{ fcTotalSelectedAmount }}
          </div>
          <button type="button" class="fv2-btn-primary" (click)="fcMakePayment()">
            <i class="ph ph-hand-coins"></i><span>{{ 'makePayment' | translate }}</span>
          </button>
        </div>
      </div>

      <!-- Step 2: payment details (amount + late fee waive-off) -->
      <div class="fv2-panel" *ngIf="fcWizardStep === 'payment' && canCollectFees">
        <div class="fv2-details-head">
          <h3>{{ 'paymentDetails' | translate }}</h3>
          <button type="button" class="fv2-btn-ghost" (click)="fcBackToSelect()">
            <i class="ph ph-arrow-left"></i><span>{{ 'back' | translate }}</span>
          </button>
        </div>
        <div class="fv2-modal-body" style="padding-top:0;">
          <label class="fv2-field-label">{{ 'payableAmount' | translate }}</label>
          <input type="number" class="fv2-field-input" [(ngModel)]="fcPayableAmount" />

          <div class="fv2-field-row" style="align-items:center; margin-top:14px;" *ngIf="fcPayableLateFee > 0">
            <label class="fv2-checkbox-row" style="flex:1;">
              <input type="checkbox" [checked]="fcApplyLateFee" (click)="fcCheckWaiveOffLateFee($event)" />
              {{ 'includeLateFee' | translate }}: {{ currencySymbol }}{{ fcPayableLateFee }}
            </label>
          </div>

          <ng-container *ngIf="fcIsOldFee">
            <label class="fv2-field-label">{{ 'oldFeePaidOnDate' | translate }}</label>
            <div class="fv2-field-row">
              <input type="date" class="fv2-field-input" [(ngModel)]="fcOldFeeDate" />
              <input type="time" class="fv2-field-input" style="width:120px;" [(ngModel)]="fcOldFeeTime" />
            </div>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-primary" (click)="fcProceedToPaymentMode()">
            {{ 'proceed' | translate }}
          </button>
        </div>
      </div>

      <!-- Step 3: mode of payment -->
      <div class="fv2-panel" *ngIf="fcWizardStep === 'mode' && canCollectFees">
        <div class="fv2-details-head">
          <h3>{{ 'modeOfPayment' | translate }}</h3>
          <button type="button" class="fv2-btn-ghost" (click)="fcBackToPaymentDetails()">
            <i class="ph ph-arrow-left"></i><span>{{ 'back' | translate }}</span>
          </button>
        </div>
        <div class="fv2-modal-body" style="padding-top:0;">
          <div class="fv2-field-row" style="flex-wrap:wrap; gap:8px;">
            <button type="button" class="fv2-mode-btn" *ngFor="let m of ['Cash','Card','Card&Cash','QRCode','Bank-transfer','DD','Cheque']"
              [class.fv2-mode-btn-active]="fcPaymentMode === m" (click)="fcChangePaymentMode(m)">
              {{ fcModeLabelKey(m) | translate }}
            </button>
          </div>

          <ng-container [ngSwitch]="fcPaymentMode">
            <ng-container *ngSwitchCase="'Card'">
              <label class="fv2-field-label">{{ 'invoiceReferenceNo' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcCardReferenceNumber" />
            </ng-container>

            <ng-container *ngSwitchCase="'QRCode'">
              <label class="fv2-field-label">{{ 'invoiceReferenceNo' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcQrReferenceNumber" />
              <label class="fv2-field-label">{{ 'date' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="fcQrDate" />
            </ng-container>

            <ng-container *ngSwitchCase="'Card&Cash'">
              <h4 class="fv2-pay-title">{{ 'addReferenceNoPayDetail' | translate }}</h4>
              <p class="fv2-pay-amount"><span>{{ 'payableAmount' | translate }}</span> {{ currencyCode }} {{ fcPayableWithLateFee }}/-</p>
              <label class="fv2-field-label">{{ 'invoiceReferenceNo' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcCardCashReferenceNumber" />
              <label class="fv2-field-label" style="margin-top:12px;">{{ 'cardAmount' | translate }} ({{ currencyCode }})</label>
              <input type="number" class="fv2-field-input" [(ngModel)]="fcCardAmount" />
              <label class="fv2-field-label" style="margin-top:12px;">{{ 'cashAmount' | translate }} ({{ currencyCode }}) <span class="fv2-pay-note">({{ 'lateFeesShouldBeIncludedInTheCashAmountOnly' | translate }})</span></label>
              <input type="number" class="fv2-field-input" [(ngModel)]="fcCashAmount" />
            </ng-container>

            <ng-container *ngSwitchCase="'Bank-transfer'">
              <label class="fv2-field-label">{{ 'bankNameAndBranch' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcBankName" />
              <label class="fv2-field-label">{{ 'date' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="fcBankTransferDate" />
              <label class="fv2-field-label">{{ 'referenceNumber' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcBankTransferNumber" />
            </ng-container>

            <ng-container *ngSwitchCase="'DD'">
              <label class="fv2-field-label">{{ 'bankNameAndBranch' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcBankName" />
              <div class="fv2-field-row">
                <div style="flex:1;">
                  <label class="fv2-field-label">{{ 'date' | translate }}</label>
                  <input type="date" class="fv2-field-input" [(ngModel)]="fcDdDate" />
                </div>
                <div style="flex:1;">
                  <label class="fv2-field-label">{{ 'ddNumber' | translate }}</label>
                  <input type="text" class="fv2-field-input" [(ngModel)]="fcDdNumber" />
                </div>
              </div>
              <div class="fv2-field-row">
                <div style="flex:1;">
                  <label class="fv2-field-label">{{ 'micrCode' | translate }}</label>
                  <input type="text" class="fv2-field-input" [(ngModel)]="fcDdMicrCode" />
                </div>
                <div style="flex:1;">
                  <label class="fv2-field-label">{{ 'ddAmount' | translate }}</label>
                  <input type="number" class="fv2-field-input" [(ngModel)]="fcDdAmount" />
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'Cheque'">
              <label class="fv2-field-label">{{ 'bankNameAndBranch' | translate }}</label>
              <input type="text" class="fv2-field-input" [(ngModel)]="fcBankName" />
              <div class="fv2-field-row">
                <div style="flex:1;">
                  <label class="fv2-field-label">{{ 'date' | translate }}</label>
                  <input type="date" class="fv2-field-input" [(ngModel)]="fcChequeDate" />
                </div>
                <div style="flex:1;">
                  <label class="fv2-field-label">{{ 'chequeNumber' | translate }}</label>
                  <input type="text" class="fv2-field-input" [(ngModel)]="fcChequeNumber" />
                </div>
              </div>
              <label class="fv2-field-label">{{ 'chequeAmount' | translate }}</label>
              <input type="number" class="fv2-field-input" [(ngModel)]="fcChequeAmount" />
            </ng-container>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-primary" (click)="fcProceedToPayment()">
            {{ 'proceed' | translate }}
          </button>
        </div>
      </div>
    </ng-container>


    <!-- ================= History ================= -->
    <ng-container *ngIf="fcSection === 'history'">
      <div class="fv2-panel">
        <div class="fv2-details-head">
          <h3>{{ 'history' | translate }}</h3>
        </div>
        <div class="fv2-modal-body" style="padding-top:0;">
          <div class="fv2-field-row fv2-range-row">
            <div>
              <label class="fv2-field-label">{{ 'from' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="fchStart" />
            </div>
            <div>
              <label class="fv2-field-label">{{ 'to' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="fchEnd" />
            </div>
            <button type="button" class="fv2-chip-toggle" *ngIf="canSeeLateFeeSubTab" [class.active]="fchLateFee" (click)="fchToggleLateFee()">
              <i class="ph" [ngClass]="fchLateFee ? 'ph-check-square' : 'ph-square'"></i>{{ 'lateFees' | translate }}
            </button>
            <button type="button" class="fv2-btn-primary" style="height:38px;" [disabled]="fchSummaryLoading" (click)="fchViewDetails()">
              <i class="ph ph-eye"></i><span>{{ fchSummaryLoading ? ('pleaseWait' | translate) : ('viewDetails' | translate) }}</span>
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="fchLoaded">
        <div class="fv2-panel" style="margin-top:12px;">
          <div class="fv2-details-head">
            <h3>{{ 'feesCollectionByModeOfPayment' | translate }}</h3>
          </div>
          <div class="fv2-empty" *ngIf="fchSummaryLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <div class="fv2-mode-grid" *ngIf="!fchSummaryLoading">
            <div class="fv2-mode-card" *ngFor="let m of fchModeCards" [class.fv2-mode-card-total]="m.key === 'total'">
              <span class="fv2-mode-card-icon"><i class="ph" [ngClass]="m.icon"></i></span>
              <div>
                <small>{{ m.key | translate }}</small>
                <b>{{ currencySymbol }}{{ fchModes[m.amount] || 0 }}</b>
                <em>{{ fchModes[m.students] || 0 }} {{ 'students' | translate }}</em>
              </div>
            </div>
          </div>
        </div>

        <div class="fv2-panel" style="margin-top:12px;" *ngIf="fchAdmins.length > 0">
          <div class="fv2-details-head">
            <h3>{{ 'feesCollectedByEachAdmin' | translate }}</h3>
          </div>
          <div class="fv2-wrap">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'admin' | translate }}</th>
                  <th>{{ 'cash' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'card' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'qrCode' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'bankTransfer' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'dd' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'cheque' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'totalCollected' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'lateFee' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'viewMore' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let col of fchAdmins">
                  <td class="fv2-money">{{ col.collectedBy }}</td>
                  <td>{{ col.collectedAsCash }}</td>
                  <td>{{ col.collectedAsCard }}</td>
                  <td>{{ col.collectedQRCodeAmount || 0 }}</td>
                  <td>{{ col.collectedAsBankTransfer }}</td>
                  <td>{{ col.collectedAsDD }}</td>
                  <td>{{ col.collectedAsCheque }}</td>
                  <td class="fv2-money">{{ col.collectedAmount }}</td>
                  <td>{{ col.collectedLateFee }}</td>
                  <td>
                    <a class="fv2-link" (click)="fcOpenHeadwise('ADMIN_WISE', col.CreatedBy, col.collectedBy, '')">{{ 'feeWise' | translate }}</a>
                    <span class="fv2-link-sep">|</span>
                    <a class="fv2-link" (click)="fcOpenDeletedFee(col.CreatedBy, col.collectedBy)">{{ 'deletedFee' | translate }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="fv2-panel" style="margin-top:12px;">
          <div class="fv2-details-head">
            <h3>{{ 'feesCollectionByStudent' | translate }}</h3>
            <div style="display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
              <a class="fv2-link" *ngIf="canSeeLateFeeSubTab" (click)="fchOpenPaidLateFee()">{{ 'lateFeeCollectionByStudent' | translate }}</a>
              <button type="button" class="fv2-btn-ghost" [disabled]="fchTotal === 0" (click)="fchExport('xlsx')">
                <i class="ph ph-file-xls"></i><span>Excel</span>
              </button>
              <button type="button" class="fv2-btn-ghost" [disabled]="fchTotal === 0" (click)="fchExport('csv')">
                <i class="ph ph-file-csv"></i><span>CSV</span>
              </button>
            </div>
          </div>
          <div class="fv2-modal-body" style="padding-top:0; padding-bottom:8px;">
            <div class="fv2-field-row" style="align-items:center;">
              <select class="fv2-field-input" style="width:auto;" [(ngModel)]="fchPageSize" (ngModelChange)="fchPageSizeChanged()">
                <option *ngFor="let n of fchPageSizes" [ngValue]="n">{{ n }}</option>
              </select>
              <input type="text" class="fv2-field-input" style="flex:1; min-width:180px;" [(ngModel)]="fchSearch"
                (keyup.enter)="fchSearchChanged()" [placeholder]="'search' | translate" />
              <button type="button" class="fv2-btn-primary" style="height:38px;" (click)="fchSearchChanged()">
                <i class="ph ph-magnifying-glass"></i><span>{{ 'search' | translate }}</span>
              </button>
            </div>
          </div>
          <div class="fv2-wrap">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th *ngFor="let col of fchColumns; let i = index" class="fv2-th-sort" (click)="fchSort(i)">
                    {{ col.label | translate }}<span *ngIf="col.field === 'Amount' || col.field === 'lateFees'"> ({{ currencySymbol }})</span>
                    <i class="ph" *ngIf="fchSortCol === i" [ngClass]="fchSortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="fchTableLoading"><td [attr.colspan]="fchColumns.length"><i class="ph ph-circle-notch fv2-spin"></i> {{ 'pleaseWait' | translate }}</td></tr>
                <tr *ngIf="!fchTableLoading && fchRows.length === 0"><td [attr.colspan]="fchColumns.length">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                <tr *ngFor="let r of fchRows">
                  <td class="fv2-money">{{ r.studentName }}</td>
                  <td>{{ r.parentName }}</td>
                  <td>{{ r.mobileNumber }}</td>
                  <td>{{ r.Amount }}</td>
                  <td>{{ r.lateFees }}</td>
                  <td>{{ r.className }}</td>
                  <td>{{ r.feeName }}</td>
                  <td>{{ r.feeType }}</td>
                  <td>{{ r.collectionDate | date: 'dd-MMM-yyyy hh:mm a' }}</td>
                  <td>{{ r.creditDate && r.creditDate !== '-' ? (r.creditDate | date: 'dd-MMM-yyyy') : '-' }}</td>
                  <td>{{ r.ModeOfPayment }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="fv2-modal-foot" style="justify-content:space-between; align-items:center;">
            <span style="font-size:12px; color:#8c8c8c;">{{ fchTotal }} {{ 'total' | translate }}</span>
            <div style="display:flex; gap:8px; align-items:center;">
              <button type="button" class="fv2-btn-ghost" [disabled]="fchPage <= 1" (click)="fchGoToPage(fchPage - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
              <span style="font-size:12px; font-weight:600;">{{ fchPage }} / {{ fchTotalPages }}</span>
              <button type="button" class="fv2-btn-ghost" [disabled]="fchPage >= fchTotalPages" (click)="fchGoToPage(fchPage + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- ================= Reports ================= -->
    <ng-container *ngIf="fcSection === 'reports'">
      <div class="fv2-panel">
        <div class="fv2-details-head">
          <h3>{{ 'reports' | translate }}</h3>
        </div>
        <div class="fv2-modal-body" style="padding-top:0;">
          <div class="fv2-field-row fv2-range-row">
            <div>
              <label class="fv2-field-label">{{ 'from' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="fcrStart" />
            </div>
            <div>
              <label class="fv2-field-label">{{ 'to' | translate }}</label>
              <input type="date" class="fv2-field-input" [(ngModel)]="fcrEnd" />
            </div>
            <button type="button" class="fv2-chip-toggle" *ngIf="canSeeLateFeeSubTab" [class.active]="fcrLateFee" (click)="fcrToggleLateFee()">
              <i class="ph" [ngClass]="fcrLateFee ? 'ph-check-square' : 'ph-square'"></i>{{ 'lateFees' | translate }}
            </button>
          </div>
          <div class="fv2-report-links">
            <button type="button" class="fv2-report-link" [disabled]="!fcrDateRangeSelected"
              (click)="fcOpenHeadwise('SINGLE_ACADEMIC', null, '', 'dayWiseHeadFees')">
              <i class="ph ph-calendar-check"></i>{{ 'dayWiseHeadFees' | translate }} ({{ currentAcademicYearLabel }})
            </button>
            <button type="button" class="fv2-report-link" [disabled]="!fcrDateRangeSelected"
              (click)="fcOpenHeadwise('ALL_ACADEMICS', null, '', 'dayWiseHeadFeesAllAcademics')">
              <i class="ph ph-calendar-dots"></i>{{ 'dayWiseHeadFeesAllAcademics' | translate }}
            </button>
            <button type="button" class="fv2-report-link" [disabled]="!fcrDateRangeSelected"
              (click)="fcOpenHeadwise('ACADEMIC_WISE', null, '', 'academicWiseHeadFeesAllAcademics')">
              <i class="ph ph-graduation-cap"></i>{{ 'academicWiseHeadFeesAllAcademics' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Head-wise collection modal -->
    <div class="fv2-modal-backdrop" *ngIf="fcHeadwiseOpen" (click)="fcCloseHeadwise()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3 *ngIf="fcFeeReportType === 'ADMIN_WISE'">{{ 'feeCollectedBy' | translate }} {{ fcSelectedAdminName }}</h3>
          <h3 *ngIf="fcFeeReportType !== 'ADMIN_WISE'">{{ fcHeadwiseTitle | translate }}<span *ngIf="fcFeeReportType === 'SINGLE_ACADEMIC'"> ({{ currentAcademicYearLabel }})</span></h3>
          <button type="button" class="fv2-modal-close" (click)="fcCloseHeadwise()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="fcHeadwiseLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <ng-container *ngIf="!fcHeadwiseLoading">
            <div style="margin-bottom:12px;" *ngIf="fcAdminCollectedFees.data.length > 0">
              <button type="button" class="fv2-btn-ghost" (click)="fcExportHeadwiseToExcel()"><i class="ph ph-file-xls"></i><span>{{ 'export' | translate }}</span></button>
            </div>
            <div class="fv2-wrap">
              <table class="fv2-table">
                <thead>
                  <tr>
                    <th *ngIf="fcFeeReportType !== 'ACADEMIC_WISE'">{{ 'date' | translate }}</th>
                    <th *ngIf="fcFeeReportType === 'ACADEMIC_WISE'">{{ 'academicYear' | translate }}</th>
                    <th *ngIf="fcFeeReportType === 'ALL_ACADEMICS'">{{ 'academic' | translate }}</th>
                    <th *ngFor="let name of fcAdminCollectedFees.allFeeNames">{{ name }}</th>
                    <th>{{ 'totalCash' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'totalCard' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'totalQrCode' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'totalBank' | translate }} {{ 'transfer' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'total' | translate }} {{ 'dd' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'total' | translate }} {{ 'cheque' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'total' | translate }} {{ 'online' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'total' | translate }} {{ 'fee' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'total' | translate }} {{ 'lateFees' | translate }} ({{ currencySymbol }})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="fcAdminCollectedFees.data.length === 0"><td colspan="12">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                  <tr *ngFor="let f of fcAdminCollectedFees.data">
                    <td class="fv2-money">{{ f.date || f.year }}</td>
                    <td *ngIf="fcFeeReportType === 'ALL_ACADEMICS'">{{ headwiseAcademicsText(f) }}</td>
                    <td *ngFor="let _name of fcAdminCollectedFees.allFeeNames">{{ f[_name] || 0 }}</td>
                    <td>{{ f.totalCash || 0 }}</td>
                    <td>{{ f.totalCard || 0 }}</td>
                    <td>{{ f.collectedAsQRCode || 0 }}</td>
                    <td>{{ f.collectedAsBankTransfer || 0 }}</td>
                    <td>{{ f.collectedAsDD || 0 }}</td>
                    <td>{{ f.collectedAsCheque || 0 }}</td>
                    <td>{{ f.collectedAsOnline || 0 }}</td>
                    <td class="fv2-money">{{ f.totalFee }}</td>
                    <td>{{ f.lateFees || 0 }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="fcCloseHeadwise()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Fees deleted by an admin -->
    <div class="fv2-modal-backdrop" *ngIf="fcDeletedFeeOpen" (click)="fcCloseDeletedFee()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'feeDeletedBy' | translate }} {{ fcSelectedAdminName }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fcCloseDeletedFee()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="fcDeletedFeeLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <div class="fv2-wrap" *ngIf="!fcDeletedFeeLoading">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'studentName' | translate }}</th>
                  <th>{{ 'fatherName' | translate }}</th>
                  <th>{{ 'registrationId' | translate }}</th>
                  <th>{{ 'feeName' | translate }}</th>
                  <th>{{ 'feeType' | translate }}</th>
                  <th>{{ 'mode' | translate }}</th>
                  <th>{{ 'amount' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'reason' | translate }}</th>
                  <th>{{ 'deletedOn' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="fcAdminCancelledFees.length === 0"><td colspan="9">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                <tr *ngFor="let f of fcAdminCancelledFees">
                  <td class="fv2-money">{{ f.studentName }}</td>
                  <td>{{ f.parentName }}</td>
                  <td>{{ f.registrationId }}</td>
                  <td>{{ f.Name }}</td>
                  <td>{{ f.feeType }}</td>
                  <td>{{ f.ModeOfPayment }}</td>
                  <td>{{ f.Amount }}</td>
                  <td>{{ f.Reason }}</td>
                  <td>{{ f.UpdatedOn }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="fcCloseDeletedFee()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Late fee collected by student -->
    <div class="fv2-modal-backdrop" *ngIf="fchPaidLateFeeOpen" (click)="fchClosePaidLateFee()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'lateFeeCollectionByStudent' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fchClosePaidLateFee()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="fchPaidLateFeeLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <div class="fv2-wrap" *ngIf="!fchPaidLateFeeLoading">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'studentName' | translate }}</th>
                  <th>{{ 'parentName' | translate }}</th>
                  <th>{{ 'registrationNumber' | translate }}</th>
                  <th>{{ 'class' | translate }}</th>
                  <th>{{ 'feeName' | translate }}</th>
                  <th>{{ 'feeType' | translate }}</th>
                  <th>{{ 'lateFees' | translate }} ({{ currencySymbol }})</th>
                  <th>{{ 'date' | translate }}</th>
                  <th>{{ 'collectedBy' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="fchPaidLateFeeList.length === 0"><td colspan="9">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                <tr *ngFor="let r of fchPaidLateFeeList">
                  <td class="fv2-money">{{ r.studentName }}</td>
                  <td>{{ r.parentName }}</td>
                  <td>{{ r.registrationId }}</td>
                  <td>{{ r.class }}</td>
                  <td>{{ r.displayFeeName }}</td>
                  <td>{{ r.displayFeeType }}</td>
                  <td>{{ r.lateFees }}</td>
                  <td>{{ r.displayDate }}</td>
                  <td>{{ r.adminName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="fchClosePaidLateFee()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Term fee breakup — what the old screen showed on clicking a term's name -->
    <div class="fv2-modal-backdrop fv2-modal-top" *ngIf="fcAllAcademicOpen" (click)="fcAllAcademicOpen = false">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'studentAllAcademicsPendingFee' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fcAllAcademicOpen = false"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-wrap">
            <table class="fv2-table fv2-table-compact">
              <thead><tr><th>{{ 'academicYear' | translate }}</th><th>{{ 'pendingFee' | translate }}</th><th>{{ 'action' | translate }}</th></tr></thead>
              <tbody>
                <tr *ngFor="let a of fcAllAcademicFee">
                  <td>{{ a.old_year }}</td>
                  <td>{{ currencySymbol }}{{ a.balanceFee }}</td>
                  <td><a *ngIf="a.balanceFee > 0" style="text-decoration:underline;font-weight:700;cursor:pointer;color:var(--brand-primary-color);" (click)="fcSwitchAcademic(a.old_ac_id)">{{ 'collect' | translate }}</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="fv2-modal-backdrop fv2-modal-top" *ngIf="fcDeleteOpen" (click)="fcDeleteOpen = false">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'delete' | translate }} — {{ fcDeleteFee?.ReceiptNumber }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fcDeleteOpen = false"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div *ngIf="fcDeleteStep === 1">
            <label class="fv2-field-label">{{ 'selectReason' | translate }}</label>
            <select class="fv2-field-input" [(ngModel)]="fcDeleteReasonSel" [ngModelOptions]="{standalone: true}">
              <option value="0">{{ 'select' | translate }}</option>
              <option *ngFor="let r of fcDeleteReasons" [value]="r.pkFeesCollectionUpdateReasonsId">{{ r.Reason }}</option>
              <option value="NEW">{{ 'addNewReason' | translate }}</option>
            </select>
            <input *ngIf="fcDeleteReasonSel === 'NEW'" type="text" class="fv2-field-input" style="margin-top:10px;" [(ngModel)]="fcDeleteNewReason" [ngModelOptions]="{standalone: true}" />
          </div>
          <div *ngIf="fcDeleteStep === 2">
            <label class="fv2-field-label">{{ 'pleaseEnterYourLoginPasswordToProceed' | translate }}</label>
            <input type="password" class="fv2-field-input" [(ngModel)]="fcDeletePassword" [ngModelOptions]="{standalone: true}" autocomplete="new-password" />
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="fcDeleteOpen = false">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fcDeleteBusy" (click)="fcDeleteProceed()">{{ (fcDeleteStep === 1 ? 'proceed' : 'delete') | translate }}</button>
        </div>
      </div>
    </div>

    <div class="fv2-modal-backdrop fv2-modal-top" *ngIf="fcBreakupOpen" (click)="fcBreakupOpen = false">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ fcBreakupTitle }} — {{ 'feeBreakup' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fcBreakupOpen = false"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-wrap">
            <table class="fv2-table fv2-table-compact">
              <thead><tr><th>{{ 'feeComponent' | translate }}</th><th>{{ 'fees' | translate }} ({{ currencySymbol }})</th></tr></thead>
              <tbody>
                <tr *ngFor="let f of fcBreakupRows"><td class="fv2-money">{{ f.Name }}</td><td>{{ f.Amount }}</td></tr>
                <tr *ngIf="fcBreakupRows.length === 0"><td colspan="2" class="fv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="fcBreakupOpen = false">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Edit student info — the same shared popup the old Fee Collection opened
         when the student's name was clicked. -->
    <app-edit-student-popup-v2 *ngIf="fcEditStudentOpen && fcStudentFeeDashDetails?.student" [currType]="currencyCode"
      (save_button_event)="fcEditStudentSaved()" (closePopup)="fcCloseEditStudent()" [button_text]="'Save'"
      [visible]="'block'" [studentName]="fcStudentFeeDashDetails.student.studentName"
      [studentId]="fcStudentFeeDashDetails.student.studentId" [academicId]="currentAcademicId"
      [academicYear]="currentAcademicYearLabel"></app-edit-student-popup-v2>

    <!-- Payment preview/confirmation modal -->
    <div class="fv2-modal-backdrop" *ngIf="fcPreviewOpen" (click)="closePreview()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'confirmPayment' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closePreview()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div style="font-size:12.5px; color:#575d6b; display:flex; flex-direction:column; gap:8px;">
            <div><b>{{ 'studentName' | translate }}:</b> {{ fcPreviewReqObj?.studentDetail?.studentName }}</div>
            <div><b>{{ 'modeOfPayment' | translate }}:</b> {{ fcPreviewReqObj?.ModeOfPayment }}</div>
            <div><b>{{ 'payableAmount' | translate }}:</b> {{ currencySymbol }}{{ fcPayableAmount }}</div>
            <div *ngIf="fcApplyLateFee && fcPayableLateFee > 0"><b>{{ 'lateFee' | translate }}:</b> {{ currencySymbol }}{{ fcPayableLateFee }}</div>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closePreview()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="fcPaySaving" (click)="fcYesProceedPay()">
            {{ fcPaySaving ? ('pleaseWait' | translate) : ('yesProceed' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Late fee waive-off confirm modal -->
    <div class="fv2-modal-backdrop" *ngIf="fcWaiveOffConfirmOpen" (click)="closeWaiveOffConfirm()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-body" style="text-align:center;">
          <h4>{{ 'areYouSureYouWantToWaiveOffTheLateFeeThisCannotBeUndone' | translate }}</h4>
        </div>
        <div class="fv2-modal-foot" style="justify-content:center;">
          <button type="button" class="fv2-btn-ghost" (click)="closeWaiveOffConfirm()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" (click)="fcConfirmWaiveOffLateFee()">{{ 'waiveOff' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Receipt modal — ports FeesManagementComponent's #view-receipt 1:1
         for information density (header/student/payment-mode meta,
         fee-line table with fee/disc/paid columns, total/late-fee/net/
         received-amount summary rows, signatory footer) against the same
         getFeeReceipt_v3 response, restyled in the fv2-* design language.
         Both of the old component's Chq/DD summary-row variants are
         normalized to the fuller one here rather than reproducing its own
         template inconsistency between the two isFeesModuleEnable modes. -->
    <div class="fv2-modal-backdrop" *ngIf="fcReceiptOpen" (click)="fcCloseReceipt()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'feeReceipt' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fcCloseReceipt()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div id="fv2-receipt-print-container" class="fv2-receipt">
            <div class="fv2-receipt-head">
              <h2>{{ fcReceiptStudent?.schoolName }}</h2>
              <p *ngIf="fcReceiptStudent?.locality || fcReceiptStudent?.address">
                {{ fcReceiptStudent?.locality }}{{ fcReceiptStudent?.locality && fcReceiptStudent?.address ? ' - ' : '' }}{{ fcReceiptStudent?.address }}
              </p>
              <div class="fv2-receipt-title">{{ 'feeReceipt' | translate }}</div>
            </div>

            <div class="fv2-receipt-meta">
              <div class="fv2-receipt-meta-col">
                <div><span>{{ 'receiptNo' | translate }}</span><b>{{ fcReceiptStudent?.ReceiptNumber }}</b></div>
                <div><span>{{ 'name' | translate }}</span><b>{{ fcReceiptStudent?.studentName }}</b></div>
                <div><span>{{ 'parentName' | translate }}</span><b>{{ fcReceiptStudent?.parentName }}</b></div>
                <div><span>{{ 'class' | translate }}</span><b>{{ fcReceiptStudent?.classNumber }} - {{ fcReceiptStudent?.classDivision }}</b></div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'DD' || fcReceiptStudent?.ModeOfPayment === 'Cheque'">
                  <span>{{ 'bankName' | translate }}</span><b>{{ fcReceiptStudent?.BankName }}</b>
                </div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'DD' || fcReceiptStudent?.ModeOfPayment === 'Cheque'">
                  <span>{{ 'clearDate' | translate }}</span><b>{{ fcReceiptStudent?.ModeOfPayDate | date: 'dd-MMM-yyyy' }}</b>
                </div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'QRCode' || fcReceiptStudent?.ModeOfPayment === 'Bank-transfer'">
                  <span>{{ 'creditDate' | translate }}</span><b>{{ fcReceiptStudent?.ModeOfPayDate | date: 'dd-MMM-yyyy' }}</b>
                </div>
              </div>
              <div class="fv2-receipt-meta-col">
                <div><span>{{ 'date' | translate }}</span><b>{{ fcReceiptStudent?.CreatedDate | date: 'dd-MMM-yyyy' }}</b></div>
                <div><span>{{ 'admissionNo' | translate }}</span><b>{{ fcReceiptStudent?.registrationId }}</b></div>
                <div><span>{{ 'transactionId' | translate }}</span>
                  <b>{{ fcReceiptStudent?.ModeOfPayment === 'Online' ? fcReceiptStudent?.paymentId : (fcReceiptStudent?.ReferenceNumber || 'NA') }}</b>
                </div>
                <div><span>{{ 'modOfPayment' | translate }}</span>
                  <b>{{ fcReceiptStudent?.ModeOfPayment === 'Card&Cash' ? 'Card & Cash' : fcReceiptStudent?.ModeOfPayment }}</b>
                </div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'DD'"><span>{{ 'ddNumber' | translate }}</span><b>{{ fcReceiptStudent?.DDNumber }}</b></div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'Cheque'"><span>{{ 'chequeNumber' | translate }}</span><b>{{ fcReceiptStudent?.ChequeNumber }}</b></div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'DD' && fcReceiptStudent?.ddAmount"><span>{{ 'ddAmount' | translate }}</span><b>{{ currencySymbol }}{{ fcReceiptStudent?.ddAmount }}</b></div>
                <div *ngIf="fcReceiptStudent?.ModeOfPayment === 'Cheque' && fcReceiptStudent?.chequeAmount"><span>{{ 'chequeAmount' | translate }}</span><b>{{ currencySymbol }}{{ fcReceiptStudent?.chequeAmount }}</b></div>
              </div>
            </div>

            <div class="fv2-wrap">
              <table class="fv2-table fv2-receipt-table">
                <thead>
                  <tr>
                    <th>{{ 'fee' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'feeAmt' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'disAmt' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'paidAmt' | translate }} ({{ currencySymbol }})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of fcReceipt; let i = index">
                    <td class="fv2-money">
                      <ng-container *ngIf="p.TermName">{{ p.TermName }}<ng-container *ngIf="p.feeType?.Name"> ({{ p.feeType.Name }})</ng-container></ng-container>
                      <ng-container *ngIf="!p.TermName">{{ p.isBusFee ? ('transport' | translate) + ' (' + p.name + ')' : p.name }}</ng-container>
                    </td>
                    <td>{{ p.feeType ? (p.feeType.PaymentAmount ?? p.ActualAmount) : p.ActualAmount }}</td>
                    <!-- When the fees module is ENABLED and this row starts a
                         term's FeesTypes group (colExists), Discount/Paid
                         rowspan across that group instead of repeating per
                         row — matches the old receipt's #feeReceiptTable
                         exactly (feesmanage.component.html:3966-3975). For
                         every other row (no TermName, or TermName but not
                         the group's first/only row) render a plain cell —
                         skipping both would silently drop the column, as
                         it did for isFeesModuleEnable != 'ENABLED' schools
                         (p.colExists is never set there). -->
                    <td *ngIf="p.TermName && fcReceiptSetting.isFeesModuleEnable === 'ENABLED' && p.colExists" [attr.rowspan]="p.FeesTypes?.length || 1">{{ p.DiscountAmount || 0 }}</td>
                    <td *ngIf="!p.TermName || fcReceiptSetting.isFeesModuleEnable !== 'ENABLED'">{{ p.DiscountAmount || 0 }}</td>
                    <td *ngIf="p.TermName && fcReceiptSetting.isFeesModuleEnable === 'ENABLED' && p.colExists" [attr.rowspan]="p.FeesTypes?.length || 1">{{ p.Amount }}</td>
                    <td *ngIf="!p.TermName || fcReceiptSetting.isFeesModuleEnable !== 'ENABLED'">{{ p.Amount }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="fv2-receipt-total-row">
                    <td>{{ 'totalAmount' | translate }}</td>
                    <td>{{ fcGetActualTotalAmount() }}</td>
                    <td>{{ fcGetDiscountTotalAmount() }}</td>
                    <td>{{ fcGetTotalAmount() }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'lateFeeAmount' | translate }}{{ fcGetModeOfPayment() === 'Card&Cash' ? ' (' + ('cashAmount' | translate) + ')' : '' }}</td>
                    <td></td>
                    <td></td>
                    <td>{{ fcGetTotalLateFeeAmount() }}</td>
                  </tr>
                  <tr class="fv2-receipt-total-row">
                    <td>{{ 'netAmount' | translate }}</td>
                    <td></td>
                    <td></td>
                    <td>{{ fcGetActualTotalAmount() }}</td>
                  </tr>

                  <tr *ngIf="fcGetModeOfPayment() === 'Cash'">
                    <td>{{ 'receivedAmountCash' | translate }}</td>
                    <td></td><td></td>
                    <td>{{ fcGetTotalAmount() }}</td>
                  </tr>
                  <ng-container *ngIf="fcGetModeOfPayment() === 'Card&Cash'">
                    <tr>
                      <td>{{ 'receivedAmountCard' | translate }}</td>
                      <td></td><td></td>
                      <td>{{ fcGetTotalCardAmount() }}</td>
                    </tr>
                    <tr>
                      <td>{{ 'receivedAmountCash' | translate }}</td>
                      <td></td><td></td>
                      <td>{{ fcGetTotalCashAmount() }}</td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="fcGetModeOfPayment() === 'Card'">
                    <td>{{ 'receivedAmount' | translate }} ({{ fcGetModeOfPayment() }})</td>
                    <td></td><td></td>
                    <td>{{ fcGetTotalAmount() }}</td>
                  </tr>
                  <tr *ngIf="fcGetModeOfPayment() === 'Cheque'">
                    <td>{{ 'receivedAmount' | translate }} ({{ 'cheque' | translate }})</td>
                    <td>{{ 'cheque' | translate }} {{ 'no' | translate }}: {{ fcGetChequeNumber() }}</td>
                    <td>{{ 'cheque' | translate }} {{ 'date' | translate }}: {{ fcGetModeOfPayDate() | date: 'dd-MMM-yyyy' }}</td>
                    <td>{{ fcGetTotalAmount() }}</td>
                  </tr>
                  <tr *ngIf="fcGetModeOfPayment() === 'DD'">
                    <td>{{ 'receivedAmount' | translate }} ({{ fcGetModeOfPayment() }})</td>
                    <td>{{ 'ddNo' | translate }}: {{ fcReceiptStudent?.DDNumber }}</td>
                    <td>{{ 'ddDate' | translate }}: {{ fcGetModeOfPayDate() | date: 'dd-MMM-yyyy' }}</td>
                    <td>{{ fcGetTotalAmount() }}</td>
                  </tr>

                  <tr class="fv2-receipt-total-row">
                    <td>{{ 'totalReceivedAmount' | translate }}</td>
                    <td></td><td></td>
                    <td>{{ fcGetTotalReceivedAmount() }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="fv2-receipt-footer">
              <div></div>
              <div class="fv2-receipt-signatory">{{ 'authSignatory' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="fcCloseReceipt()">{{ 'close' | translate }}</button>
          <button type="button" class="fv2-btn-primary" (click)="fcPrintReceipt()">
            <i class="ph ph-printer"></i><span>{{ 'print' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Payment history modal -->
    <div class="fv2-modal-backdrop" *ngIf="fcHistoryTab" (click)="fcCloseHistory()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ (fcHistoryMode === 'updates' ? 'paymentUpdateHistory' : 'paymentHistory') | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="fcCloseHistory()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-subtabs" style="margin-bottom:12px;">
            <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="fcHistoryMode === 'history'" (click)="fcSetHistoryMode('history')">{{ 'paymentHistory' | translate }}</button>
            <button type="button" class="fv2-subtab" [class.fv2-subtab-active]="fcHistoryMode === 'updates'" (click)="fcSetHistoryMode('updates')">{{ 'paymentUpdateHistory' | translate }}</button>
          </div>

          <ng-container *ngIf="fcHistoryMode === 'updates'">
            <div class="fv2-empty" *ngIf="fcUpdateHistoryLoading"><i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i></div>
            <div class="fv2-wrap" *ngIf="!fcUpdateHistoryLoading">
              <table class="fv2-table">
                <thead>
                  <tr>
                    <th>{{ 'receiptNo' | translate }}</th>
                    <th>{{ 'feeName' | translate }}</th>
                    <th>{{ 'paidAmount' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'discount' | translate }} ({{ currencySymbol }})</th>
                    <th>{{ 'paymentMode' | translate }}</th>
                    <th>{{ 'paidDate' | translate }}</th>
                    <th>{{ 'action' | translate }}</th>
                    <th>{{ 'doneBy' | translate }}</th>
                    <th>{{ 'dateOfAction' | translate }}</th>
                    <th>{{ 'reason' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="fcUpdateHistoryList.length === 0"><td colspan="10" class="fv2-empty-cell">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                  <tr *ngFor="let h of fcUpdateHistoryList">
                    <td>{{ h.ReceiptNumber }}</td>
                    <td class="fv2-money">{{ h.isBusFee == 1 ? ('transport' | translate) + ' (' + h.Name + ')' : h.Name }}</td>
                    <td>{{ h.Amount }}</td>
                    <td>{{ h.DiscountAmount }}</td>
                    <td>{{ h.ModeOfPayment }}</td>
                    <td>{{ h.CreatedDate | date: 'dd-MMM-yyyy' }}</td>
                    <td>{{ 'cancelled' | translate }}</td>
                    <td>{{ h.username }}</td>
                    <td>{{ h.UpdatedOn }}</td>
                    <td>{{ h.Reason }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <div class="fv2-wrap" *ngIf="fcHistoryMode === 'history' && !fcHistoryLoading">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'receiptNo' | translate }}</th>
                  <th>{{ 'feeName' | translate }}</th>
                  <th>{{ 'amount' | translate }}</th>
                  <th>{{ 'lateFee' | translate }}</th>
                  <th>{{ 'paidDate' | translate }}</th>
                  <th>{{ 'mode' | translate }}</th>
                  <th>{{ 'collectedBy' | translate }}</th>
                  <th>{{ 'viewReceipt' | translate }}</th>
                </tr>
              </thead>
              <tbody *ngIf="fcHistoryList.length > 0; else fv2NoHistory">
                <tr *ngFor="let h of fcHistoryList">
                  <td>{{ h.ReceiptNumber }}</td>
                  <td class="fv2-money">{{ h.Name }}{{ h.isBusFee ? (' (' + ('transport' | translate) + ')') : '' }}</td>
                  <td>{{ currencySymbol }}{{ h.Amount }}</td>
                  <td>{{ currencySymbol }}{{ h.lateFees || 0 }}</td>
                  <td>{{ h.CreatedDate }}</td>
                  <td>{{ h.ModeOfPayment || ('discount' | translate) }}</td>
                  <td>{{ h.username }}</td>
                  <td>
                    <button type="button" class="fv2-row-icon-btn" *ngIf="!h.isLoading" (click)="fcShowReceiptFromHistory(h)" [attr.aria-label]="'viewReceipt' | translate">
                      <i class="ph ph-receipt"></i>
                    </button>
                    <button type="button" class="fv2-row-icon-btn" *ngIf="!h.isLoading && canDeleteCollectedFee" (click)="fcOpenDeleteFee(h)" [attr.aria-label]="'delete' | translate">
                      <i class="ph ph-trash"></i>
                    </button>
                    <i *ngIf="h.isLoading" class="ph ph-circle-notch fv2-spin"></i>
                  </td>
                </tr>
              </tbody>
              <ng-template #fv2NoHistory>
                <tbody>
                  <tr><td colspan="8">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                </tbody>
              </ng-template>
            </table>
          </div>
          <div class="fv2-empty" *ngIf="fcHistoryMode === 'history' && fcHistoryLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
        </div>
        <div class="fv2-modal-foot" *ngIf="fcHistoryMode === 'updates'">
          <button type="button" class="fv2-btn-ghost" [disabled]="fcUpdateHistoryPage <= 1" (click)="fcUpdateHistoryGo(-1)">
            <i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span>
          </button>
          <button type="button" class="fv2-btn-ghost" [disabled]="fcUpdateHistoryIsLastPage" (click)="fcUpdateHistoryGo(1)">
            <span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i>
          </button>
        </div>
        <div class="fv2-modal-foot" *ngIf="fcHistoryMode === 'history'">
          <button type="button" class="fv2-btn-ghost" [disabled]="fcHistoryPage <= 1" (click)="fcPreviousHistoryPage()">
            <i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span>
          </button>
          <button type="button" class="fv2-btn-ghost" [disabled]="fcHistoryIsLastPage" (click)="fcNextHistoryPage()">
            <span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Discounts tab — ports FeesManagementComponent's discount
       table + Add/Apply/Applied/Delete modals 1:1 against the same
       feeService endpoints (see feesmanage-v2.component.ts). -->
  <ng-container *ngIf="activeTab === 'discounts'">
    <div class="fv2-panel">
      <div class="fv2-details-head">
        <h3>{{ 'discounts' | translate }}</h3>
        <button type="button" class="fv2-btn-primary" (click)="openAddDiscountModal()">
          <i class="ph ph-plus"></i><span>{{ 'addNewDiscount' | translate }}</span>
        </button>
      </div>

      <div class="fv2-empty" *ngIf="!discountsLoading && discountList.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-seal-percent"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>

      <div class="fv2-wrap" *ngIf="discountList.length > 0">
        <table class="fv2-table">
          <thead>
            <tr>
              <th>{{ 'discountName' | translate }}</th>
              <th>{{ 'feeStructure' | translate }}</th>
              <th>{{ 'amountPercent' | translate }}</th>
              <th>{{ 'appliedToStudents' | translate }}</th>
              <th>{{ 'applyDiscount' | translate }}</th>
              <th>{{ 'delete' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let discount of discountList" [rowEntrance]="discount.pkSchoolDiscountId">
              <td class="fv2-money">{{ discount.discountName }}</td>
              <td>{{ discount.FeeStructureName || 'Default' }}</td>
              <td>{{ discount.DiscountAmountType === 'AMOUNT' ? (currencySymbol + discount.discountAmount) : (discount.discountPercentage + '%') }}</td>
              <td *ngIf="!discount.appliedTo">0</td>
              <td *ngIf="discount.appliedTo">
                <a style="cursor:pointer;text-decoration:underline;color:var(--fv2-teal)" (click)="openAppliedDiscountModal(discount)">{{ discount.appliedTo }}</a>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn" *ngIf="!discount.isLoading" (click)="openApplyDiscountModal(discount)" [attr.aria-label]="'applyDiscount' | translate">
                  <i class="ph ph-note-pencil"></i>
                </button>
                <i *ngIf="discount.isLoading" class="ph ph-circle-notch fv2-spin"></i>
              </td>
              <td>
                <button type="button" class="fv2-row-icon-btn fv2-row-icon-btn-danger" [disabled]="!!discount.appliedTo"
                  (click)="openDeleteDiscountModal(discount)" [attr.aria-label]="'delete' | translate">
                  <i class="ph ph-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Add Discount modal -->
    <div class="fv2-modal-backdrop" *ngIf="addDiscountModalOpen" (click)="closeAddDiscountModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'addNewDiscount' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeAddDiscountModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <label class="fv2-field-label">{{ 'discountName' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="addDiscount.discountName" [placeholder]="'e.g. Sibling Discount, Merit Scholarship'" />

          <label class="fv2-field-label">{{ 'feeStructure' | translate }} *</label>
          <select class="fv2-field-input" [(ngModel)]="addDiscount.feeStructuresId">
            <option value="general">{{ 'generalDefault' | translate }}</option>
            <option *ngFor="let o of feeStructureListForSelect" [ngValue]="o.pkFeeStructuresId">{{ o.Name }}</option>
          </select>

          <div class="fv2-field-row">
            <div style="width: 90px;">
              <label class="fv2-field-label">{{ 'type' | translate }}</label>
              <select class="fv2-field-input" [(ngModel)]="addDiscount.discountAmountType" (ngModelChange)="addDiscount.discountAmount = null">
                <option value="AMOUNT">{{ currencySymbol }}</option>
                <option value="PERCENT">%</option>
              </select>
            </div>
            <div style="flex: 1;">
              <label class="fv2-field-label">{{ addDiscount.discountAmountType === 'AMOUNT' ? ('amount' | translate) : ('percent' | translate) }}</label>
              <input type="number" class="fv2-field-input" [(ngModel)]="addDiscount.discountAmount" [placeholder]="addDiscount.discountAmountType === 'AMOUNT' ? 'e.g. 500' : 'e.g. 10'" />
            </div>
          </div>

          <label class="fv2-field-label">{{ 'reasonForDiscount' | translate }}</label>
          <input type="text" class="fv2-field-input" [(ngModel)]="addDiscount.discountReason" [placeholder]="'e.g. Second child enrolled in the same academic year'" />

          <label class="fv2-field-label">{{ 'feesComponents' | translate }}</label>
          <div class="fv2-discount-tree">
            <div *ngFor="let type of allFeeNames.typeList" class="fv2-discount-tree-row">
              <label class="fv2-checkbox-row">
                <input type="checkbox" [(ngModel)]="type.selected" (ngModelChange)="selectAllTermsInComponent(type, type.selected)" />
                <span [title]="type.Name">{{ truncateText(type.Name, 28) }}</span>
              </label>
              <i *ngIf="type.terms?.length && !type.expand" class="ph ph-caret-down" (click)="type.expand = true"></i>
              <i *ngIf="type.terms?.length && type.expand" class="ph ph-caret-up" (click)="type.expand = false"></i>
              <div *ngIf="type.expand" class="fv2-discount-tree-terms">
                <label class="fv2-checkbox-row" *ngFor="let term of type.terms">
                  <input type="checkbox" [(ngModel)]="term.selected" (ngModelChange)="onDiscountTermToggle(type, term)" />
                  <span [title]="term.TermName">{{ truncateText(term.TermName, 20) }}</span>
                </label>
              </div>
            </div>
          </div>

          <ng-container *ngIf="allFeeNames.busTermList?.length">
            <label class="fv2-field-label">{{ 'transport' | translate }}</label>
            <div class="fv2-discount-tree">
              <label class="fv2-checkbox-row" *ngFor="let busTerm of allFeeNames.busTermList">
                <input type="checkbox" [(ngModel)]="busTerm.selected" />
                <span [title]="busTerm.termName">{{ truncateText(busTerm.termName, 28) }}</span>
              </label>
            </div>
          </ng-container>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeAddDiscountModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="addDiscountSaving" (click)="addDiscountSubmit()">
            {{ addDiscountSaving ? ('pleaseWait' | translate) : ('proceed' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Apply Discount modal -->
    <div class="fv2-modal-backdrop" *ngIf="applyDiscountModalOpen" (click)="closeApplyDiscountModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'applyDiscount' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeApplyDiscountModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <p>{{ 'searchStudentsFrom' | translate }} <b>{{ selectedDiscount?.FeeStructureName || 'Default' }}</b> {{ 'feeStructure' | translate }}</p>
          <div class="fv2-field-row" style="align-items:center;">
            <select class="fv2-field-input" style="width:auto;" [(ngModel)]="selectedApplyDiscountSection" (ngModelChange)="searchStudentsForApplyDiscount()">
              <option value="all" *ngIf="selectedDiscount?.pkStudentsCategoryId">{{ 'allFrom' | translate }} {{ selectedDiscount?.FeeStructureName || 'Default' }}</option>
              <option *ngFor="let section of classSectionsInStudentCategory" [ngValue]="section.classId">{{ section.classNumber }} - {{ section.classDivision }}</option>
            </select>
            <label class="fv2-checkbox-row">
              <input type="checkbox" [checked]="isStudentActiveForDiscount" [disabled]="discountLoader" (click)="toggleDiscountActiveFilter()" />
              {{ 'activeStudentsOnly' | translate }}
            </label>
          </div>

          <div class="fv2-wrap" *ngIf="!discountLoader">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th><input type="checkbox" (change)="selectAllDiscountStudents($event.target.checked)" /> {{ 'selectAll' | translate }}</th>
                  <th>{{ 'studentName' | translate }}</th>
                  <th>{{ 'parentName' | translate }}</th>
                  <th>{{ 'registrationNumber' | translate }}</th>
                  <th>{{ 'mobileNo' | translate }}</th>
                  <th>{{ 'class' | translate }}</th>
                </tr>
              </thead>
              <tbody *ngIf="discountStudentList.length > 0; else fv2NoDiscountStudents">
                <tr *ngFor="let student of discountStudentList">
                  <td><input type="checkbox" [(ngModel)]="student.select" /></td>
                  <td>{{ student.studentName }}</td>
                  <td>{{ student.parentName }}</td>
                  <td>{{ student.registrationId }}</td>
                  <td>{{ student.mobileNumber }}</td>
                  <td>{{ student.className }}</td>
                </tr>
              </tbody>
              <ng-template #fv2NoDiscountStudents>
                <tbody>
                  <tr><td colspan="6">{{ 'noDataAvailableInTable' | translate }}</td></tr>
                </tbody>
              </ng-template>
            </table>
          </div>
          <div class="fv2-empty" *ngIf="discountLoader">
            <i class="ph ph-circle-notch fv2-spin" style="font-size: 24px;"></i>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeApplyDiscountModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="applyDiscountSaving" (click)="applyDiscountSubmit()">
            {{ applyDiscountSaving ? ('pleaseWait' | translate) : ('apply' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Applied Discount Students modal -->
    <div class="fv2-modal-backdrop" *ngIf="appliedDiscountModalOpen" (click)="closeAppliedDiscountModal()">
      <div class="fv2-modal fv2-modal-wide" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'appliedDiscountHistory' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeAppliedDiscountModal()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-wrap">
            <table class="fv2-table">
              <thead>
                <tr>
                  <th>{{ 'studentName' | translate }}</th>
                  <th>{{ 'registrationNumber' | translate }}</th>
                  <th>{{ 'discountAmount' | translate }} ({{ currencyCode }})</th>
                  <th>{{ 'class' | translate }}</th>
                  <th>{{ 'feeName' | translate }}</th>
                  <th>{{ 'discountedOn' | translate }}</th>
                  <th>{{ 'receiptNo' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of appliedDiscountStudentList" [style.background]="row.isBlocked === 1 ? '#F8E1E5' : ''">
                  <td>{{ row.studentName }}</td>
                  <td>{{ row.registrationId }}</td>
                  <td>{{ currencySymbol }}{{ row.DiscountAmount }}</td>
                  <td>{{ row.classNumber }}-{{ row.classDivision }}</td>
                  <td *ngIf="row.TermName && row.TypeName">{{ row.TypeName }}-{{ row.TermName }} {{ 'term' | translate }}</td>
                  <td *ngIf="!row.TermName && row.TypeName">{{ row.TypeName }} {{ 'other' | translate }}</td>
                  <td *ngIf="row.busTermName">{{ row.busTermName }} {{ 'transport' | translate }}</td>
                  <td>{{ row.CreatedDate }}</td>
                  <td>{{ row.ReceiptNumber }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeAppliedDiscountModal()">{{ 'close' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Delete Discount modal -->
    <div class="fv2-modal-backdrop" *ngIf="deleteDiscountModalOpen" (click)="closeDeleteDiscountModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-body" style="text-align:center;">
          <h4>{{ 'areYouConfirmToDelete' | translate }} <b><i>{{ selectedDiscount?.discountName }}</i></b> {{ 'discount' | translate }}</h4>
        </div>
        <div class="fv2-modal-foot" style="justify-content:center;">
          <button type="button" class="fv2-btn-ghost" (click)="closeDeleteDiscountModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="deleteDiscountSaving" (click)="deleteDiscountConfirm()">
            {{ deleteDiscountSaving ? ('pleaseWait' | translate) : ('delete' | translate) }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Settings tab — ports FeesManagementComponent's getFeesSettings()/
       changeSetting()/getClassFeesSettings()/updateClassFeeSettings()/
       fetchPaymentGateways()/sendRequest()/onCheckboxChange()/
       getSupportedCurrency()/handleSupportedCurrencyChange() against the
       same feeService endpoints (see feesmanage-v2.component.ts). Scope:
       the 4 sections that actually render in production today — the
       legacy Instamojo merchant-account/purpose/payment-limits sub-tree
       is dead code in the old component (permanently gated behind a
       hardcoded false flag) and is NOT ported. -->
  <ng-container *ngIf="activeTab === 'settings'">
    <!-- Module toggles -->
    <div class="fv2-panel">
      <div class="fv2-details-head">
        <h3>{{ 'fv2FeesModuleSettings' | translate }}</h3>
      </div>
      <div class="fv2-modal-body" style="padding-top:0;">
        <div class="fv2-settings-row">
          <div>
            <b>{{ 'mobileFeesModule' | translate }}</b>
            <p>{{ 'mobileFeesModuleDescription' | translate }}</p>
          </div>
          <div class="fv2-toggle-pair">
            <button type="button" class="fv2-mode-btn" [class.fv2-mode-btn-active]="isMobileFeesModuleEnabled"
              [disabled]="settingSaving['MOBILE_FEES_MODULE']" (click)="changeSetting('MOBILE_FEES_MODULE','ENABLED')">{{ 'enable' | translate }}</button>
            <button type="button" class="fv2-mode-btn" [class.fv2-mode-btn-active]="!isMobileFeesModuleEnabled"
              [disabled]="settingSaving['MOBILE_FEES_MODULE']" (click)="changeSetting('MOBILE_FEES_MODULE','DISABLED')">{{ 'disable' | translate }}</button>
          </div>
        </div>

        <div class="fv2-settings-row" *ngIf="isMobileFeesModuleEnabled">
          <div>
            <b>{{ 'mobileFeesPayment' | translate }}</b>
            <p>{{ 'mobileFeesPaymentDescription' | translate }}</p>
          </div>
          <div class="fv2-toggle-pair">
            <button type="button" class="fv2-mode-btn" [class.fv2-mode-btn-active]="isMobileFeesPaymentEnabled"
              [disabled]="settingSaving['MOBILE_FEES_PAYMENT']" (click)="changeSetting('MOBILE_FEES_PAYMENT','ENABLED')">{{ 'enable' | translate }}</button>
            <button type="button" class="fv2-mode-btn" [class.fv2-mode-btn-active]="!isMobileFeesPaymentEnabled"
              [disabled]="settingSaving['MOBILE_FEES_PAYMENT']" (click)="changeSetting('MOBILE_FEES_PAYMENT','DISABLED')">{{ 'disable' | translate }}</button>
          </div>
        </div>

        <div class="fv2-settings-row" *ngIf="isMobileFeesModuleEnabled && isMobileFeesPaymentEnabled">
          <div>
            <b>{{ 'onlinePaymentForEachClassSection' | translate }}</b>
            <p>{{ 'onlinePaymentForEachClassSectionDescription' | translate }}</p>
          </div>
          <button type="button" class="fv2-btn-primary" (click)="openClassFeesSettings()">
            <i class="ph ph-list-checks"></i><span>{{ 'addRemove' | translate }}</span>
          </button>
        </div>

        <div class="fv2-settings-row">
          <div>
            <b>{{ 'showTermFeeBreakup' | translate }}</b>
            <p>{{ 'showTermFeeBreakupDescription' | translate }}</p>
          </div>
          <div class="fv2-toggle-pair">
            <button type="button" class="fv2-mode-btn" [class.fv2-mode-btn-active]="isShowTermFeeBreakupEnabled"
              [disabled]="settingSaving['SHOW_TERM_FEE_BREAKUP']" (click)="changeSetting('SHOW_TERM_FEE_BREAKUP','ENABLED')">{{ 'enable' | translate }}</button>
            <button type="button" class="fv2-mode-btn" [class.fv2-mode-btn-active]="!isShowTermFeeBreakupEnabled"
              [disabled]="settingSaving['SHOW_TERM_FEE_BREAKUP']" (click)="changeSetting('SHOW_TERM_FEE_BREAKUP','DISABLED')">{{ 'disable' | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment gateway list -->
    <div class="fv2-panel" *ngIf="isGatewayEnable">
      <div class="fv2-details-head">
        <h3>{{ 'gatewaySelection' | translate }}</h3>
      </div>
      <div class="fv2-empty" *ngIf="paymentGatewaysLoading">
        <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
      </div>
      <div class="fv2-empty" *ngIf="!paymentGatewaysLoading && paymentGateways.length === 0">
        <span class="fv2-em-icon"><i class="ph ph-credit-card"></i></span>
        <b>{{ 'noDataAvailableInTable' | translate }}</b>
      </div>
      <div class="fv2-gateway-grid" *ngIf="!paymentGatewaysLoading && paymentGateways.length > 0">
        <div class="fv2-gateway-card" *ngFor="let gateway of paymentGateways">
          <div class="fv2-gateway-card-head">
            <input type="checkbox" class="fv2-gateway-checkbox" [checked]="gateway.isActive === 1" [disabled]="gateway.isConfigured !== 1 || gateway.loader" (change)="onGatewayCheckboxChange(gateway)" />
            <button type="button" class="fv2-gateway-request-btn" *ngIf="gateway.isConfigured !== 1" (click)="openGatewayRequestModal(gateway)">
              {{ 'sendRequest' | translate }}
            </button>
            <span *ngIf="gateway.isConfigured === 1" class="fv2-gateway-configured">{{ 'configured' | translate }}</span>
          </div>
          <div class="fv2-gateway-info">
            <img [src]="gateway.paymentGatewayLogo" alt="" />
            <p>{{ gateway.paymentGatewayName }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Currency selector -->
    <div class="fv2-panel" *ngIf="supportedCurrencyList.length > 0">
      <div class="fv2-details-head">
        <h3>{{ 'supportedCurrency' | translate }}</h3>
      </div>
      <div class="fv2-gateway-grid">
        <label class="fv2-currency-card" *ngFor="let currency of supportedCurrencyList" [class.fv2-currency-card-active]="currency.isCurrentCurrency === 1">
          <input type="radio" name="fv2-currency" [checked]="currency.isCurrentCurrency === 1" [disabled]="currency.loader" (change)="handleSupportedCurrencyChange(currency)" />
          <span>{{ currency.currencyType }}</span>
          <i *ngIf="currency.loader" class="ph ph-circle-notch fv2-spin"></i>
        </label>
      </div>
    </div>

    <!-- Per-class online payment modal -->
    <div class="fv2-modal-backdrop" *ngIf="classFeesSettingsOpen" (click)="closeClassFeesSettings()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-head">
          <h3>{{ 'onlinePaymentInClassSections' | translate }}</h3>
          <button type="button" class="fv2-modal-close" (click)="closeClassFeesSettings()"><i class="ph ph-x"></i></button>
        </div>
        <div class="fv2-modal-body">
          <div class="fv2-empty" *ngIf="classFeesSettingsLoading">
            <i class="ph ph-circle-notch fv2-spin" style="font-size:24px;"></i>
          </div>
          <div class="fv2-class-grid" *ngIf="!classFeesSettingsLoading">
            <label class="fv2-checkbox-row" *ngFor="let s of classFeesSettings">
              <input type="checkbox" [(ngModel)]="s.selected" />
              <span>{{ s.classNumber }} - {{ s.classDivision }}</span>
            </label>
            <div class="fv2-empty" *ngIf="classFeesSettings.length === 0">
              <b>{{ 'looksLikeThereAreNoClassesAvailable' | translate }}</b>
            </div>
          </div>
        </div>
        <div class="fv2-modal-foot">
          <button type="button" class="fv2-btn-ghost" (click)="closeClassFeesSettings()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="classFeesSettingsSaving" (click)="updateClassFeeSettings()">
            {{ classFeesSettingsSaving ? ('pleaseWait' | translate) : ('save' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Gateway request confirm modal -->
    <div class="fv2-modal-backdrop" *ngIf="gatewayRequestModalOpen" (click)="closeGatewayRequestModal()">
      <div class="fv2-modal" (click)="$event.stopPropagation()">
        <div class="fv2-modal-body" style="text-align:center;">
          <h4>{{ 'configureGatewayRequestConfirm' | translate }}</h4>
        </div>
        <div class="fv2-modal-foot" style="justify-content:center;">
          <button type="button" class="fv2-btn-ghost" (click)="closeGatewayRequestModal()">{{ 'cancel' | translate }}</button>
          <button type="button" class="fv2-btn-primary" [disabled]="gatewayRequestSaving" (click)="sendGatewayRequest()">
            {{ gatewayRequestSaving ? ('pleaseWait' | translate) : ('sendRequest' | translate) }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>

    </section>
    <!-- end .dv2-section -->
  </div>
  <!--end #content-->
</div>
<!--end #base-->
